import {
  Box,
  Button,
  Divider,
  FormControlLabel,
  FormGroup,
  Grid,
  Checkbox,
  Typography,
  useTheme,
  TextField,
  Modal,
  FormControl,
  RadioGroup,
  Radio,
  Snackbar,
  Alert,
  AlertTitle,
  FormLabel,
  DialogActions,
} from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import queryString from "query-string";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import FlightLandIcon from "@mui/icons-material/FlightLand";
import FlightTakeoffIcon from "@mui/icons-material/FlightTakeoff";
import HorizontalRuleIcon from "@mui/icons-material/HorizontalRule";
import LoadingButton from "@mui/lab/LoadingButton";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import {
  checkLoggedInUserPcc,
  emailItinerary,
  getCustomerLogos,
  getCustomerUserLogos,
  getLoggedInCustomer,
  getLoggedInCustomerLogins,
  getLoggedInCustomerUser,
  getManageBookingData,
  printItinerary,
  updateCustomerUserDefaultLogo,
  updateCustomerDefaultLogo,
} from "../../redux/actions/CustomerAction";
import FullPageLoader from "../../Components/FullPageLoader";
import NotificationPopup from "../../Components/NotificationPopup";
import "../../CSS/DisplayItinerary.css";
import PrintIcon from "@mui/icons-material/Print";
import EmailIcon from "@mui/icons-material/Email";
import styled from "styled-components";
import AccessTimeIcon from "@mui/icons-material/AccessTime"; // Clock Icon from MUI
import {
  EMAIL_ITINERARY_DATA_RESET,
  PRINT_ITINERARY_DATA_RESET,
} from "../../Constants/Constants";

const StyledTextField = styled(TextField)({
  backgroundColor: "#EEEEEE",
  // width: "auto",
  // display: "inline-block",
  padding: "4px 8px",
  borderRadius: "4px",
  fontFamily: "inherit",
  lineHeight: "inherit",
  "& .MuiInputBase-root": {
    backgroundColor: "transparent",
  },
  "& .MuiInputBase-input": {
    fontSize: "14px",
    padding: 0,
    textAlign: "left",
  },
  "& .MuiOutlinedInput-notchedOutline": {
    border: "none",
  },
});

export default function DisplayItinerary(props) {
  const { decodedToken } = props;
  const location = useLocation();
  const dispatch = useDispatch();
  let lastDisplayedGroup = null;

  const token = JSON.parse(localStorage.getItem("userInfo"));

  const [visibleCount, setVisibleCount] = useState(5);
  const [openModal, setOpenModal] = useState(false);
  const [openPDFModal, setOpenPDFModal] = useState(false);
  const [customerEmail, setCustomerEmail] = useState("");
  const [customerCC, setCustomerCC] = useState("");
  const [updatedHotel, setUpdatedHotel] = useState([]);
  const [updatedVehicle, setUpdatedVehicle] = useState([]);
  const [filteredFields, setFilteredFields] = useState([
    "PD",
    "TicketNumber",
    "AgencyName",
    "PNR", // Agency reference
    "check-in",
    "BC", // Booking class
    "activeSeg", // Active Segmemts
    // "Co2",
    // "Fare",
    // "OptionalService",
    "Baggage",
    // "FareCal",
    // "Hotel",
    // "Vehicle",
    "UR", // Unassociated Remarks
    // "npft", // Notepad Remarks
    // "di", // Accounting Remarks
    // "Header",
    // "Footer",
    // "TaxBreakdown",
  ]);
  const [hideFilters, setHideFilters] = useState(false);
  const [bookingTraveler, setBookingTraveler] = useState([]);
  const [bookingTravelerOtherInfo, setBookingTravelerOtherInfo] = useState([]);
  const [extraCharges, setExtraCharges] = useState([]);
  const [extraChargesTotalPrice, setExtraChargesTotalPrice] = useState(null);
  const [passengerData, setPassengerData] = useState({});
  const [agencyName, setAgencyName] = useState([]);
  const [agencyNumber, setAgencyNumber] = useState([]);
  const [pnr, setPnr] = useState("");
  const [passengerSelection, setPassengerSelection] = useState([]);
  const [segmentSelection, setSegmentSelection] = useState([]);
  const [selectAllPassenger, setSelectAllPassenger] = useState(true);
  const [selectAllSegment, setSelectAllSegment] = useState(true);
  const [hotelTotal, setHotelTotal] = useState(null);
  const [vehicleTotal, setVehicleTotal] = useState(null);
  const [totalPriceOfAllTickets, setTotalPriceOfAllTickets] = useState(null);
  const [remarkInfo, setRemarkInfo] = useState([]);
  const [npftRemark, setNpftRemark] = useState([]);
  const [passiveRemark, setPassiveRemark] = useState([]);
  const [diRemark, setDiRemark] = useState([]);
  const [flightTimesByGroup, setFlightTimesByGroup] = useState({});
  const [pdfChoice, setpdfChoice] = useState("");
  const [snackOpen, setSnackOpen] = useState(false);
  const [errorAlert, setErrorAlert] = useState(false);
  const [errorAlertMessage, setErrorAlertMessage] = useState("");
  const [language, setLanguage] = useState("en");
  const [services, setServices] = useState([{ type: "", fee: "" }]);
  const [totalServiceFees, setTotalServiceFees] = useState(null);
  const [itinerary_data, setItinerary_data] = useState(null);
  const [air_segments, setAir_segments] = useState(null);
  const [checkIn_hours, setCheckIn_hours] = useState(3);
  const [openLoader, setOpenLoader] = useState(false);
  const [header_logo, setHeader_logo] = useState(null);
  const [footer_logo, setFooter_logo] = useState(null);
  const [customer_header_logo, setCustomer_header_logo] = useState(null); // State for customer header logo
  const [customer_main_header_logo, setCustomer_main_header_logo] =
    useState(false); // State for customer main logo
  const [customer_main_footer_logo, setCustomer_main_footer_logo] =
    useState(false); // State for customer main footer logo
  const [customer_footer_logo, setCustomer_footer_logo] = useState(null); // State for customer footer logo
  const [headerLogoModalOpen, setHeaderLogoModalOpen] = useState(false); // State for header logo modal
  const [selectedHeaderLogo, setSelectedHeaderLogo] = useState(null); // State for selected header logo
  const [selectedCustomerHeaderLogo, setSelectedCustomerHeaderLogo] =
    useState(null); // State for selected customer header logo
  const [footerLogoModalOpen, setFooterLogoModalOpen] = useState(false); // State for footer logo modal
  const [selectedFooterLogo, setSelectedFooterLogo] = useState(null); // State for selected footer logo
  const [selectedCustomerFooterLogo, setSelectedCustomerFooterLogo] =
    useState(null); // State for selected customer footer logo
  const { locator: statePNR, pcc: statePCC } = location.state || {};

  const { locator: UrlPnr, pcc: urlPcc } = queryString.parse(location.search);

  const locator = sessionStorage.getItem("pnr");
  const pcc = sessionStorage.getItem("pcc");

  const customer_id = JSON.parse(localStorage.getItem("customer_id"));
  const cust_login_id = JSON.parse(localStorage.getItem("customer_login_id"));
  const customer_user_id = JSON.parse(localStorage.getItem("customer_user_id"));

  const check_pcc_id = customer_user_id ? customer_user_id : customer_id;

  const GetManageBookingData = useSelector(
    (state) => state.GetManageBookingData
  );

  const { loading, itineraryInfo, error } = GetManageBookingData;

  const CheckLoggedInUserPCC = useSelector(
    (state) => state.CheckLoggedInUserPCC
  );
  const { loggedInUserPCCInfo, loggedInUserPCCerror } = CheckLoggedInUserPCC;

  const EmailItineraryData = useSelector((state) => state.EmailItineraryData);

  const { emailItineraryLoading, emailItineraryInfo, emailItineraryError } =
    EmailItineraryData;

  const PrintItineraryData = useSelector((state) => state.PrintItineraryData);

  const { printItineraryLoading, printItineraryInfo, printItineraryError } =
    PrintItineraryData;

  const GetLoggedInCustomerUser = useSelector(
    (state) => state.GetLoggedInCustomerUser
  );
  const { loggedInCustomerUserInfo } = GetLoggedInCustomerUser;

  const GetCustomerUserLogos = useSelector(
    (state) => state.GetCustomerUserLogos
  );
  const { customerUserLogosInfo } = GetCustomerUserLogos;

  const GetLoggedInCustomerLogins = useSelector(
    (state) => state.GetLoggedInCustomerLogins
  );
  const { loggedInCustomerLoginsInfo } = GetLoggedInCustomerLogins;

  const GetCustomerLogos = useSelector((state) => state.GetCustomerLogos);
  const { customerLogosInfo } = GetCustomerLogos;

  const currency =
    bookingTraveler
      ?.find((item) => item?.BasePrice)
      ?.BasePrice?.substring(0, 3) ||
    (itinerary_data?.hotel_info?.length > 0
      ? itinerary_data?.hotel_info[0]?.Rate?.substring(0, 3)
      : null);

  const passengerCounts = {};
  itinerary_data?.booking_traveler?.forEach((item) => {
    const type = item?.PassengerType;
    if (type) {
      passengerCounts[type] = (passengerCounts[type] || 0) + 1;
    }
  });
  let displayedPassengerTypes = new Set();
  let displayedPassengerTypesFareCalc = new Set();

  // Baggage and carray on allowance
  const travelerTypeOrder = ["ADT", "CNN", "INF"];
  const displayBaggage = {};

  const getDistinctBaggageInfo = (type) => {
    const seenRoutes = new Set();
    return (
      itinerary_data?.baggage_allowance?.filter((item) => {
        const route = `${item.From}-${item.To}`;
        if (item.TravelerType === type && !seenRoutes.has(route)) {
          seenRoutes.add(route);
          return true;
        }
        return false;
      }) || []
    );
  };

  travelerTypeOrder.forEach((type) => {
    displayBaggage[type] = getDistinctBaggageInfo(type);
  });

  const formatTime = (totalMinutes) => {
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;
    return `${hours}h ${minutes}m`;
  };

  //   Calculate the total flight time for each group
  const calculateFlightTimes = () => {
    const result = {};
    let groupCounter = {};
    let maxGroup = 0;

    itinerary_data?.air_segments_info?.forEach((segment) => {
      const group = Number(parseInt(segment.Group, 10));
      if (group > maxGroup) {
        maxGroup = group;
      }
    });

    itinerary_data?.air_segments_info?.forEach((segment) => {
      const group = Number(segment.Group);
      let totalFlightTime = 0;
      // let sum_totalFlightTime = 0;

      segment?.FlightDetails?.length > 0
        ? segment?.FlightDetails?.forEach((detail) => {
          if (detail.FlightTime) {
            totalFlightTime += parseInt(detail.FlightTime, 10) || 0;
          } else if (detail.TravelTime) {
            totalFlightTime += parseInt(detail.TravelTime, 10) || 0;
          }
        })
        : (totalFlightTime = 0);

      if (totalFlightTime > 0) {
        totalFlightTime += parseInt(segment.DurationInMinute, 10) || 0;
      }

      if (!groupCounter[group]) {
        groupCounter[group] = 0;
      }

      let groupLabel;
      if (maxGroup <= 1) {
        groupLabel = group === 0 ? "Outbound" : "Inbound";
      } else {
        groupLabel = `Outbound ${group + 1}`;
      }

      if (!result[groupLabel]) {
        result[groupLabel] = {
          group: group,
          totalFlightTime: 0,
          formattedFlightTime: "",
        };
      }

      // sum_totalFlightTime += totalFlightTime;
      result[groupLabel].totalFlightTime += totalFlightTime;
      result[groupLabel].formattedFlightTime = formatTime(
        result[groupLabel].totalFlightTime
      );
    });

    setFlightTimesByGroup(result);
  };

  useEffect(() => {
    dispatch({ type: "CHECK_LOGGED_IN_USER_PCC_RESET" });
  }, []);

  useEffect(() => {
    if (token) {
      if (customer_id || cust_login_id) {
        dispatch(getLoggedInCustomer(customer_id));
        dispatch(getLoggedInCustomerLogins(cust_login_id));
        dispatch(getCustomerLogos(cust_login_id));
      }
      if (customer_user_id) {
        dispatch(getLoggedInCustomerUser(customer_user_id));
        dispatch(getCustomerUserLogos(customer_user_id));
      }
    }
  }, [token]);

  useEffect(() => {
    if (loggedInCustomerUserInfo && customerUserLogosInfo) {
      const header =
        loggedInCustomerUserInfo?.header
          ?.trim()
          ?.split(" ")
          ?.map((id) => parseInt(id, 10)) || [];

      if (header.length === 1) {
        setSelectedHeaderLogo(header[0]);
        const default_logo_data = { default_header: header[0] };

        dispatch(
          updateCustomerUserDefaultLogo(customer_user_id, default_logo_data)
        );
      }

      const footer =
        loggedInCustomerUserInfo?.footer
          ?.trim()
          ?.split(" ")
          ?.map((id) => parseInt(id, 10)) || [];

      if (footer.length === 1) {
        setSelectedFooterLogo(footer[0]);
        const default_logo_data = { default_footer: footer[0] };
        dispatch(
          updateCustomerUserDefaultLogo(customer_user_id, default_logo_data)
        );
      }

      const headerLogos = customerUserLogosInfo?.filter((logo) =>
        header.includes(logo.logo_id)
      );
      setHeader_logo(headerLogos);

      const footerLogos = customerUserLogosInfo?.filter((logo) =>
        footer.includes(logo.logo_id)
      );
      setFooter_logo(footerLogos);
      setSelectedHeaderLogo(loggedInCustomerUserInfo?.default_header);
      setSelectedFooterLogo(loggedInCustomerUserInfo?.default_footer);
    }
  }, [loggedInCustomerUserInfo, customerUserLogosInfo]);

  useEffect(() => {
    if (loggedInCustomerLoginsInfo && customerLogosInfo) {
      const header =
        loggedInCustomerLoginsInfo?.header
          ?.trim()
          ?.split(" ")
          ?.map((id) => parseInt(id, 10)) || [];

      if (header.length === 1) {
        setSelectedCustomerHeaderLogo(header[0]);
        const default_logo_data = { default_header: header[0] };

        dispatch(updateCustomerDefaultLogo(cust_login_id, default_logo_data));
      }

      const footer =
        loggedInCustomerLoginsInfo?.footer
          ?.trim()
          ?.split(" ")
          ?.map((id) => parseInt(id, 10)) || [];

      if (footer.length === 1) {
        setSelectedCustomerFooterLogo(footer[0]);
        const default_logo_data = { default_footer: footer[0] };
        dispatch(updateCustomerDefaultLogo(cust_login_id, default_logo_data));
      }

      const headerLogos = customerLogosInfo?.filter((logo) =>
        header.includes(logo.logo_id)
      );

      setCustomer_header_logo(headerLogos);

      const footerLogos = customerLogosInfo?.filter((logo) =>
        footer.includes(logo.logo_id)
      );
      setCustomer_footer_logo(footerLogos);
      setSelectedCustomerHeaderLogo(loggedInCustomerLoginsInfo?.default_header);
      setSelectedCustomerFooterLogo(loggedInCustomerLoginsInfo?.default_footer);

      if (loggedInCustomerLoginsInfo?.default_header === null) {
        setCustomer_main_header_logo(true);
      }
      if (loggedInCustomerLoginsInfo?.default_footer === null) {
        setCustomer_main_footer_logo(true);
      }
    }
  }, [loggedInCustomerLoginsInfo, customerLogosInfo]);

  useEffect(() => {
    if (loading) {
      setOpenLoader(true);
    } else {
      setOpenLoader(false);
    }
  }, [loading]);

  useEffect(() => {
    if (!itineraryInfo || Object.keys(itineraryInfo).length === 0) {
      if (statePNR && statePCC) {
        if (decodedToken?.role === "customer_user") {
          dispatch(
            getManageBookingData(
              statePNR,
              statePCC,
              decodedToken?.role,
              customer_user_id
            )
          );
        } else {
          dispatch(
            getManageBookingData(statePNR, statePCC, decodedToken?.role)
          );
        }
      } else if (UrlPnr && urlPcc) {
        sessionStorage.setItem("pnr", UrlPnr);
        sessionStorage.setItem("pcc", urlPcc);
        if (decodedToken?.role === "customer_user") {
          dispatch(
            getManageBookingData(
              UrlPnr,
              urlPcc,
              decodedToken?.role,
              customer_user_id
            )
          );
        } else {
          dispatch(getManageBookingData(UrlPnr, urlPcc, decodedToken?.role));
        }
      } else if (locator && pcc) {
        if (decodedToken?.role === "customer_user") {
          dispatch(
            getManageBookingData(
              locator,
              pcc,
              decodedToken?.role,
              customer_user_id
            )
          );
        } else {
          dispatch(getManageBookingData(locator, pcc, decodedToken?.role,customer_id));
        }
      }
    }
    if (itineraryInfo) {
      setItinerary_data(itineraryInfo);
    }
  }, [itineraryInfo]);

  useEffect(() => {
    if (filteredFields?.includes("activeSeg")) {
      const air_seg = itinerary_data?.air_segments_info?.filter(
        (item) => !item?.is_departed
      );
      setAir_segments(air_seg);
    } else {
      setAir_segments(itinerary_data?.air_segments_info);
    }
  }, [filteredFields]);

  useEffect(() => {
    if (pdfChoice != "") {
      setErrorAlert(false);
    }
  }, [pdfChoice]);

  useEffect(() => {
    if (emailItineraryInfo) {
      setTimeout(() => {
        setOpenModal(false);
        dispatch({ type: EMAIL_ITINERARY_DATA_RESET });
      }, 3000);
    }
  }, [emailItineraryInfo]);

  useEffect(() => {
    if (printItineraryInfo) {
      setOpenPDFModal(false);
      dispatch({ type: PRINT_ITINERARY_DATA_RESET });
    }
  }, [printItineraryInfo]);

  useEffect(() => {
    const totalFees = services.reduce((total, service) => {
      return total + (Number(service.fee) || 0);
    }, 0);

    setTotalServiceFees(totalFees.toFixed(2));
  }, [services]);

  useEffect(() => {
    if (!itinerary_data) {
      console.error("itineraryInfo is undefined. Cannot proceed.");
      return;
    }
    const clonedItineraryInfo = JSON.parse(JSON.stringify(itinerary_data));

    const totalPriceAllTickets = clonedItineraryInfo?.booking_traveler?.reduce(
      (accumulator, item) => {
        const passengerKey = item?.Key;
        const fare = passengerData[passengerKey]?.fare || null;
        const taxes = passengerData[passengerKey]?.taxes || null;
        const totalPrice = (Number(fare) + Number(taxes))?.toFixed(2);
        return accumulator + parseFloat(totalPrice);
      },
      0
    );
    setTotalPriceOfAllTickets(totalPriceAllTickets?.toFixed(2));

    const updatedHotelInfo = clonedItineraryInfo?.hotel_info?.map((item) => {
      const updatedItem = { ...item };
      if (updatedItem?.Rate) {
        updatedItem.Rate =
          String(updatedItem?.Rate?.substring(0, 3)) + hotelTotal;
      }
      return updatedItem;
    });

    setUpdatedHotel(updatedHotelInfo);

    const updatedVehicleInfo = clonedItineraryInfo?.vehicle_info?.map(
      (item) => {
        const updatedItem = { ...item };
        if (updatedItem?.estimatedTotalAmount) {
          updatedItem.estimatedTotalAmount =
            String(updatedItem?.estimatedTotalAmount?.substring(0, 3)) +
            vehicleTotal;
        }
        return updatedItem;
      }
    );

    setUpdatedVehicle(updatedVehicleInfo);

    setPnr(pnr);
  }, [passengerData, hotelTotal, vehicleTotal, pnr]);

  useEffect(() => {
    const extraChargesTotal = extraCharges?.reduce((accumulator, item) => {
      const total_cost = item?.TotalCost;
      const add_charges = item?.ExchangeTotalPrice;
      const totalPrice = (Number(total_cost) + Number(add_charges))?.toFixed(2);
      return accumulator + parseFloat(totalPrice);
    }, 0);
    setExtraChargesTotalPrice(extraChargesTotal?.toFixed(2));
  }, [extraCharges]);

  useEffect(() => {
    if (statePCC) dispatch(checkLoggedInUserPcc(check_pcc_id, statePCC));
    if (urlPcc) dispatch(checkLoggedInUserPcc(check_pcc_id, urlPcc));
    if (pcc) dispatch(checkLoggedInUserPcc(check_pcc_id, pcc));
  }, [statePCC, urlPcc, pcc]);

  useEffect(() => {
    if (loggedInUserPCCerror) {
      setErrorAlert(true);
    } else {
      setErrorAlert(false);
    }
  }, [loggedInUserPCCerror]);

  useEffect(() => {
    if (itinerary_data) {
      setCustomerEmail(itinerary_data?.customer?.email?.trim());
      setCustomerCC(itinerary_data?.customer?.cc?.trim());

      if (filteredFields?.includes("activeSeg")) {
        const air_seg = itinerary_data?.air_segments_info?.filter(
          (item) => !item?.is_departed
        );
        setAir_segments(air_seg);
      } else {
        setAir_segments(itinerary_data?.air_segments_info);
      }

      if (itinerary_data?.booking_traveler) {
        const updatedPassengerData = itinerary_data.booking_traveler.reduce(
          (acc, item) => {
            acc[item?.Key] = {
              fare: item?.BasePrice?.substring(3) || 0,
              taxes: item?.Taxes?.substring(3) || 0,
            };
            return acc;
          },
          {}
        );
        setPassengerData(updatedPassengerData);
      }

      if (Array.isArray(itinerary_data?.booking_traveler)) {
        setBookingTraveler(itinerary_data.booking_traveler);
        setBookingTravelerOtherInfo(itinerary_data.booking_traveler);
      } else {
        setBookingTraveler([]);
        setBookingTravelerOtherInfo([]);
      }

      if (Array.isArray(itinerary_data?.extra_charges)) {
        setExtraCharges(itinerary_data.extra_charges);
      } else {
        setExtraCharges([]);
      }

      if (Array.isArray(itinerary_data?.agency_name)) {
        setAgencyName(itinerary_data.agency_name);
      } else {
        setAgencyName([]);
      }

      if (Array.isArray(itinerary_data?.agency_number)) {
        setAgencyNumber(itinerary_data.agency_number);
      } else {
        setAgencyNumber([]);
      }

      setPnr(itinerary_data?.locator);
      setRemarkInfo(itinerary_data?.remarks);
      // setNpftRemark(itinerary_data?.npft_remarks);
      setDiRemark(itinerary_data?.di_remarks);
      setPassiveRemark(itinerary_data?.passive_remarks);

      const clonedItineraryInfo = JSON.parse(JSON.stringify(itinerary_data));

      const totalPriceAllTickets =
        clonedItineraryInfo?.booking_traveler?.reduce((accumulator, item) => {
          const passengerKey = item?.Key;
          const fare = passengerData[passengerKey]?.fare || null;
          const taxes = passengerData[passengerKey]?.taxes || null;
          const totalPrice = (Number(fare) + Number(taxes))?.toFixed(2);
          return accumulator + parseFloat(totalPrice);
        }, 0);
      setTotalPriceOfAllTickets(totalPriceAllTickets?.toFixed(2));

      const extraChargesTotal = clonedItineraryInfo?.extra_charges?.reduce(
        (accumulator, item) => {
          const total_cost = item?.TotalCost;
          const add_charges = item?.ExchangeTotalPrice;
          const totalPrice = (
            Number(total_cost) + Number(add_charges)
          )?.toFixed(2);
          return accumulator + parseFloat(totalPrice);
        },
        0
      );
      setExtraChargesTotalPrice(extraChargesTotal?.toFixed(2));

      itinerary_data?.hotel_info?.map((item) => {
        setHotelTotal(item?.Rate?.substring(3) || 0);
      });

      itinerary_data?.vehicle_info?.map((item) => {
        setVehicleTotal(item?.estimatedTotalAmount?.substring(3) || 0);
      });

      if (itinerary_data?.booking_traveler) {
        const keys = itinerary_data.booking_traveler.map((item) => item?.Key);
        setPassengerSelection(keys);
      }

      if (itinerary_data?.air_segments_info) {
        const keys = itinerary_data.air_segments_info.map((item) => item?.Key);
        setSegmentSelection(keys);
      }

      calculateFlightTimes();
    }
  }, [itinerary_data]);

  useEffect(() => {
    const new_booking_traveler = bookingTraveler?.filter((item) =>
      passengerSelection?.includes(item?.Key)
    );
    setBookingTravelerOtherInfo(new_booking_traveler);

    const new_extra_charges = itinerary_data?.extra_charges?.filter((charge) =>
      new_booking_traveler?.some((traveler) =>
        traveler.Number?.includes(charge.AssociatedTicketNumber)
      )
    );

    setExtraCharges(new_extra_charges);
  }, [passengerSelection, bookingTraveler]);

  useEffect(() => {
    if (!bookingTraveler || !extraCharges) return;

    const updatedExtraCharges = extraCharges.map((item) => {
      const matchedTraveler = bookingTraveler.find((traveler) =>
        traveler.Number?.includes(item.AssociatedTicketNumber)
      );

      if (matchedTraveler) {
        return {
          ...item,
          PassengerName: matchedTraveler.Name,
        };
      }
      return item;
    });

    const isChanged = updatedExtraCharges.some(
      (updatedItem, index) =>
        updatedItem.PassengerName !== extraCharges[index]?.PassengerName
    );

    if (isChanged) {
      setExtraCharges(updatedExtraCharges);
    }
  }, [bookingTraveler, extraCharges]);

  const handleFilteredFields = (event) => {
    const value = event.target.value;
    setFilteredFields((prevState) =>
      Array.isArray(prevState)
        ? event.target.checked
          ? [...prevState, value]
          : prevState.filter((v) => v !== value)
        : [value]
    );
  };

  const handleSelectAllPassenger = (event) => {
    const value = event.target.checked;
    if (value) {
      if (bookingTraveler) {
        const keys = bookingTraveler.map((item) => item?.Key);
        setPassengerSelection(keys);
      }
    } else {
      setPassengerSelection([]);
    }
    setSelectAllPassenger(value);
  };

  const handleSelectAllSegment = (event) => {
    const value = event.target.checked;
    if (value) {
      if (itinerary_data?.air_segments_info) {
        const keys = itinerary_data?.air_segments_info.map((item) => item?.Key);
        setSegmentSelection(keys);
      }
    } else {
      setSegmentSelection([]);
    }
    setSelectAllSegment(value);
  };

  const handlePassengerSelection = (event) => {
    const value = event.target.value;
    const isChecked = event.target.checked;
    setPassengerSelection((prevState) => {
      const newSelection = isChecked
        ? [...prevState, value]
        : prevState.filter((v) => v !== value);

      const allSelected = bookingTraveler?.every((item) =>
        newSelection.includes(item.Key)
      );

      setSelectAllPassenger(allSelected);

      return newSelection;
    });
  };

  // Function to update fare for a specific passenger
  const handleFareChange = (key, fare) => {
    setPassengerData((prevData) => ({
      ...prevData,
      [key]: {
        ...prevData[key],
        fare: fare,
      },
    }));
  };

  // Function to update taxes for a specific passenger
  const handleTaxesChange = (key, taxes) => {
    setPassengerData((prevData) => ({
      ...prevData,
      [key]: {
        ...prevData[key],
        taxes: taxes,
      },
    }));
  };

  const handleSegmentSelection = (event) => {
    const value = event.target.value;
    const isChecked = event.target.checked;
    setSegmentSelection((prevState) => {
      const newSelection = isChecked
        ? [...prevState, value]
        : prevState.filter((v) => v !== value);

      const allSelected = itinerary_data?.air_segments_info?.every((item) =>
        newSelection.includes(item.Key)
      );

      setSelectAllSegment(allSelected);

      return newSelection;
    });
  };

  const handleRemarkSelection = (item) => {
    setRemarkInfo((prevSelected) => {
      if (prevSelected.includes(item)) {
        return prevSelected.filter((remark) => remark !== item);
      } else {
        return [...prevSelected, item];
      }
    });
  };

  const handleNPFTRemarkSelection = (item) => {
    setNpftRemark((prevSelected) => {
      if (prevSelected.includes(item)) {
        return prevSelected.filter((remark) => remark !== item);
      } else {
        return [...prevSelected, item];
      }
    });
  };

  const handleDIRemarkSelection = (item) => {
    setDiRemark((prevSelected) => {
      if (prevSelected.includes(item)) {
        return prevSelected.filter((remark) => remark !== item);
      } else {
        return [...prevSelected, item];
      }
    });
  };

  const handlePassiveRemarksSelection = (item) => {
    setPassiveRemark((prevSelected) => {
      if (prevSelected.includes(item)) {
        return prevSelected.filter((remark) => remark !== item);
      } else {
        return [...prevSelected, item];
      }
    });
  };

  const handlePassengerDataChange = (index, field, value) => {
    const updatedTravelers = [...bookingTraveler];

    if (field.startsWith("Number.")) {
      const numberIndex = parseInt(field.split(".")[1], 10);
      const updatedNumbers = [...updatedTravelers[index].Number];
      updatedNumbers[numberIndex] = value;
      updatedTravelers[index] = {
        ...updatedTravelers[index],
        Number: updatedNumbers,
      };
    } else {
      updatedTravelers[index] = { ...updatedTravelers[index], [field]: value };
    }

    setBookingTraveler(updatedTravelers);
  };

  const handleExtraChargesDataChange = (index, field, value) => {
    const updatedCharges = [...extraCharges];
    updatedCharges[index] = { ...updatedCharges[index], [field]: value };
    setExtraCharges(updatedCharges);
  };

  const createPDFData = (choice) => {
    const itinerary_info = JSON.parse(JSON.stringify(itinerary_data));
    let new_booking_traveler = [];

    if (choice == "PDFS" || pdfChoice == "PDFS") {
      new_booking_traveler = bookingTraveler?.filter((item) =>
        passengerSelection?.includes(item?.Key)
      );
    } else {
      // new_booking_traveler = itinerary_info?.booking_traveler;
      new_booking_traveler = bookingTraveler?.filter((item) =>
        passengerSelection?.includes(item?.Key)
      );
    }

    const new_air_segments_info = air_segments?.filter((item) =>
      segmentSelection?.includes(item?.Key)
    );

    const checkIn_reference = itinerary_info?.supplier_ref?.map((item) => item);

    const new_passenger_set = new Set();
    const passenger_fare_details = bookingTraveler
      ?.map((item) => {
        const isFirstOfType = !new_passenger_set.has(item?.PassengerType);
        if (isFirstOfType) {
          new_passenger_set.add(item?.PassengerType);

          const fare = Number(passengerData[item.Key]?.fare) || 0;
          const taxes = Number(passengerData[item.Key]?.taxes) || 0;

          return {
            passengerCount: passengerCounts[item?.PassengerType],
            PassengerType: item?.PassengerType,
            Fare: fare,
            Taxes: taxes,
            TotalAmount: (fare + taxes)?.toFixed(2),
            tax_info: item?.tax_info,
            fare_calc: item?.fare_calc,
          };
        }
        return null;
      })
      .filter((details) => details !== null);

    // const clonedDisplayBaggage = JSON.parse(JSON.stringify(displayBaggage));
    const baggage_info = travelerTypeOrder?.reduce((acc, travelerType) => {
      const baggageDetails = displayBaggage[travelerType]
        ?.map((item, index) => {
          const isFirstOfItsKind =
            index === 0 ||
            displayBaggage[travelerType][index - 1].From !== item.From ||
            displayBaggage[travelerType][index - 1].To !== item.To;

          if (
            isFirstOfItsKind &&
            item?.baggage?.length > 0 &&
            item?.baggage_info?.length > 0
          ) {
            return {
              origin_distination: `${item?.From} - ${item?.To}`,
              baggage_info: item?.baggage_info,
              baggage: item?.baggage,
              url: item?.URL,
            };
          }
          return null;
        })
        .filter((details) => details !== null);
      if (baggageDetails && baggageDetails.length > 0) {
        acc = { ...acc, [travelerType]: baggageDetails };
      }

      return acc;
    }, {});

    const service_data = services?.filter(
      (service) => service.type && service.fee
    );

    const data = {
      pcc: itinerary_info?.pcc,
      customer: itinerary_info?.customer,
      logo: itinerary_info?.customer?.logo,
      header_logo:
        customer_header_logo?.length > 0
          ? itinerary_info?.customer?.header_logo
          : null,
      footer_logo:
        customer_footer_logo?.length > 0
          ? itinerary_info?.customer?.footer_logo
          : null,
      booking_traveler: filteredFields?.includes("PD")
        ? new_booking_traveler
        : [],
      booking_date: itinerary_info?.booking_date,
      show_ticket_number: filteredFields.includes("TicketNumber"),
      show_booking_class: filteredFields.includes("BC"),
      show_co2_emission: filteredFields.includes("Co2"),
      agency_name: filteredFields?.includes("AgencyName") && agencyName,
      agency_number: agencyNumber,
      agency_reference: filteredFields.includes("PNR") && pnr,
      checkIn_reference:
        filteredFields.includes("check-in") && checkIn_reference,
      flightTimesByGroup: flightTimesByGroup,
      air_segments_info: new_air_segments_info,
      bookingTravelerOtherInfo: bookingTravelerOtherInfo?.some(
        (item) => item?.OtherInfo?.length > 0
      )
        ? bookingTravelerOtherInfo
        : [],
      show_passenger_fare_details: filteredFields?.includes("Fare"),
      passenger_fare_details:
        totalPriceOfAllTickets > 0 && passenger_fare_details,
      totalPriceOfAllTickets:
        filteredFields?.includes("Fare") && totalPriceOfAllTickets,
      show_optional_service: filteredFields?.includes("OptionalService"),
      extraCharges: filteredFields?.includes("OptionalService") && extraCharges,
      extraChargesTotalPrice:
        filteredFields?.includes("OptionalService") && extraChargesTotalPrice,
      fare_taxes_currency: currency,
      show_fare_calc: filteredFields?.includes("FareCal"),
      baggage_allowance: filteredFields?.includes("Baggage") && baggage_info,
      carry_on_allowance_info:
        filteredFields?.includes("Baggage") &&
        itinerary_info?.carry_on_allowance_info,
      hotel_info: filteredFields?.includes("Hotel") && updatedHotel,
      vehicle_info: filteredFields?.includes("Vehicle") && updatedVehicle,
      remarks: filteredFields?.includes("UR") && remarkInfo,
      // npftRemark: filteredFields?.includes("npft") && npftRemark,
      diRemark: filteredFields?.includes("di") && diRemark,
      passiveRemark: filteredFields?.includes("pr") && passiveRemark,
      services:
        (filteredFields?.includes("Service") &&
          service_data.length > 0 &&
          service_data) ||
        {},
      totalServiceFees:
        filteredFields?.includes("Service") &&
        service_data.length > 0 &&
        totalServiceFees,
      show_header: filteredFields?.includes("Header"),
      show_footer: filteredFields?.includes("Footer"),
      show_taxbreakdown: filteredFields?.includes("TaxBreakdown"),
      show_technical_stops: filteredFields?.includes("stops"),
      checkIn_hours: checkIn_hours,
    };

    return data;
  };

  const handlePrintToPDF = () => {
    const data = createPDFData("PDFS");
    if (decodedToken?.role === "customer_user") {
      dispatch(
        printItinerary(data, language, decodedToken?.role, customer_user_id)
      );
    } else {
      dispatch(printItinerary(data, language, decodedToken?.role));
    }
  };

  const handleOpenPDFModal = () => {
    setOpenPDFModal(true);
  };
  const handleClosePDFModal = () => {
    setOpenPDFModal(false);
    // setpdfChoice("PDFS");
  };

  const handleOpenModal = () => {
    setOpenModal(true);
    setpdfChoice("");
  };
  const handleCloseModal = () => {
    setOpenModal(false);
    // setpdfChoice("PDFS");
  };

  const handleSendEmail = () => {
    if (pdfChoice == "") {
      setErrorAlert(true);
      setErrorAlertMessage("Oops!! Kindly make your selections first");
    } else {
      setSnackOpen(true);
      const data = createPDFData();
      const email_data = {
        to: customerEmail,
        cc: customerCC,
        choice: pdfChoice,
      };

      if (decodedToken?.role === "customer_user") {
        dispatch(
          emailItinerary(
            data,
            email_data,
            language,
            decodedToken?.role,
            customer_user_id
          )
        );
      } else {
        dispatch(
          emailItinerary(data, email_data, language, decodedToken?.role)
        );
      }
    }
  };

  const handleSnackClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackOpen(false);
  };

  // Handler to add a new service
  const handleAddService = () => {
    setServices([...services, { type: "", fee: "" }]);
  };

  // Handler to remove a service by index
  const handleRemoveService = (index) => {
    if (services.length > 1) {
      const updatedServices = services.filter((_, i) => i !== index);
      setServices(updatedServices);
    }
  };

  // Handler to update service inputs
  const handleServiceChange = (index, field, value) => {
    const updatedServices = [...services];
    updatedServices[index][field] = value;
    setServices(updatedServices);
  };

  const handleSeeMore = () => {
    setVisibleCount((prevCount) =>
      Math.min(prevCount + 5, bookingTraveler.length)
    );
  };

  const handleSeeLess = () => {
    setVisibleCount(5);
  };

  const handleHeaderLogoModalOpen = () => {
    setHeaderLogoModalOpen(true);
  };

  const handleHeaderLogoModalClose = () => {
    setHeaderLogoModalOpen(false);
  };

  const handleCustomerUserDefaultHeaderLogo = () => {
    if (header_logo?.length > 0 && selectedHeaderLogo) {
      const default_logo_data = { default_header: selectedHeaderLogo };

      dispatch(
        updateCustomerUserDefaultLogo(customer_user_id, default_logo_data)
      );
      setHeaderLogoModalOpen(false);
    }
  };

  const handleCustomerDefaultHeaderLogo = () => {
    if (
      !customer_main_header_logo &&
      customer_header_logo?.length > 0 &&
      selectedCustomerHeaderLogo
    ) {
      const default_logo_data = {
        default_header: selectedCustomerHeaderLogo,
        make_null: false,
      };
      dispatch(updateCustomerDefaultLogo(cust_login_id, default_logo_data));
      setHeaderLogoModalOpen(false);
    } else if (customer_main_header_logo) {
      const default_logo_data = {
        default_header: selectedCustomerHeaderLogo,
        make_null: true,
      };
      dispatch(updateCustomerDefaultLogo(cust_login_id, default_logo_data));
      setHeaderLogoModalOpen(false);
    }
  };
  const handleFooterLogoModalOpen = () => {
    setFooterLogoModalOpen(true);
  };

  const handleFooterLogoModalClose = () => {
    setFooterLogoModalOpen(false);
  };

  const handleCustomerUserDefaultFooterLogo = () => {
    if (footer_logo?.length > 0 && selectedFooterLogo) {
      const default_logo_data = { default_footer: selectedFooterLogo };
      dispatch(
        updateCustomerUserDefaultLogo(customer_user_id, default_logo_data)
      );
      setFooterLogoModalOpen(false);
    }
  };

  const handleCustomerDefaultFooterLogo = () => {
    if (
      !customer_main_footer_logo &&
      customer_footer_logo?.length > 0 &&
      selectedCustomerFooterLogo
    ) {
      const default_logo_data = {
        default_footer: selectedCustomerFooterLogo,
        make_null: false,
      };
      dispatch(updateCustomerDefaultLogo(cust_login_id, default_logo_data));
      setFooterLogoModalOpen(false);
    } else if (customer_main_footer_logo) {
      const default_logo_data = {
        default_footer: selectedCustomerFooterLogo,
        make_null: true,
      };
      dispatch(updateCustomerDefaultLogo(cust_login_id, default_logo_data));
      setFooterLogoModalOpen(false);
    }
  };

  return loading ? (
    <FullPageLoader open={openLoader} />
  ) : loggedInUserPCCerror && errorAlert ? (
    <NotificationPopup
      open={errorAlert}
      message={loggedInUserPCCerror}
      onClose={() => setErrorAlert(false)}
      severity={"error"}
    />
  ) : (
    <>
      <div className="wrap-mu">
        <div className="container">
          <div style={{ padding: "16px" }}>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <h2 style={{ fontSize: "30px", fontWeight: "500" }}>
                E-Ticket & Itinerary Details
              </h2>
              <div style={{ display: "flex", gap: "8px" }}>
                <Button
                  variant="outlined"
                  className="btnptpeti"
                  startIcon={<PrintIcon />}
                  onClick={handleOpenPDFModal}
                >
                  Print to PDF
                </Button>
                <Button
                  variant="contained"
                  className="btnptpeti"
                  startIcon={<EmailIcon />}
                  onClick={handleOpenModal}
                >
                  Email to Itinerary
                </Button>
              </div>
            </div>

            <div className="chekcboxtking">
              <FormControlLabel
                control={
                  <Checkbox
                    checked={hideFilters}
                    onChange={(e) => setHideFilters(e.target.checked)}
                  />
                }
                label="Hide/Unhide Filters"
              />
              {hideFilters && (
                <FormGroup
                  className="subchkboxwrap"
                  onChange={handleFilteredFields}
                >
                  <FormControlLabel
                    control={
                      <Checkbox
                        // style={{ color: "black" }}
                        value="PD"
                        checked={filteredFields?.includes("PD")}
                      />
                    }
                    label="Pax Details"
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        // style={{ color: "black" }}
                        value="TicketNumber"
                        checked={filteredFields?.includes("TicketNumber")}
                      />
                    }
                    label="Ticket Number"
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        // style={{ color: "black" }}
                        value="AgencyName"
                        checked={filteredFields?.includes("AgencyName")}
                      />
                    }
                    label="Agency Name"
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        // style={{ color: "black" }}
                        value="PNR"
                        checked={filteredFields?.includes("PNR")}
                      />
                    }
                    label="Agency Reference"
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        value="check-in"
                        checked={filteredFields?.includes("check-in")}
                      />
                    }
                    label="Check-in Reference"
                  />

                  {!filteredFields?.includes("stops") && (
                    <FormControlLabel
                      control={
                        <Checkbox
                          value="BC"
                          checked={filteredFields?.includes("BC")}
                        />
                      }
                      label="Booking class"
                    />
                  )}

                  <FormControlLabel
                    control={
                      <Checkbox
                        value="Baggage"
                        checked={filteredFields?.includes("Baggage")}
                      />
                    }
                    label="Baggage & Carry On Allowance"
                  />

                  <FormControlLabel
                    control={
                      <Checkbox
                        value="UR"
                        checked={filteredFields?.includes("UR")}
                      />
                    }
                    label="Unassociated Remark"
                  />

                  {/*<FormControlLabel
                  control={
                    <Checkbox
                      value="npft"
                      checked={filteredFields?.includes("npft")}
                    />
                  }
                  label="Notepad Remarks (NP FT)"
                />*/}

                  <FormControlLabel
                    control={
                      <Checkbox
                        value="di"
                        checked={filteredFields?.includes("di")}
                      />
                    }
                    label="Accounting Remarks (DI)"
                  />

                  {passiveRemark?.length > 0 && (
                    <FormControlLabel
                      control={
                        <Checkbox
                          value="pr"
                          checked={filteredFields?.includes("pr")}
                        />
                      }
                      label="Passive Remarks"
                    />
                  )}

                  <FormControlLabel
                    control={
                      <Checkbox
                        value="Header"
                        checked={filteredFields?.includes("Header")}
                        onChange={(e) => {
                          if (e.target.checked) {
                            handleHeaderLogoModalOpen(); // Open modal when checkbox is checked
                          }
                        }}
                      />
                    }
                    label="Agency Header"
                  />

                  <FormControlLabel
                    control={
                      <Checkbox
                        value="activeSeg"
                        checked={filteredFields?.includes("activeSeg")}
                      />
                    }
                    label="Active Segments"
                  />

                  <FormControlLabel
                    control={
                      <Checkbox
                        value="stops"
                        checked={filteredFields?.includes("stops")}
                      />
                    }
                    label="Technical Stops Details"
                  />

                  {!filteredFields?.includes("stops") && (
                    <FormControlLabel
                      control={
                        <Checkbox
                          value="Co2"
                          checked={filteredFields?.includes("Co2")}
                        />
                      }
                      label="Co2 information"
                    />
                  )}

                  <FormControlLabel
                    control={
                      <Checkbox
                        value="Fare"
                        checked={filteredFields?.includes("Fare")}
                      />
                    }
                    label="Fare and Taxes"
                  />

                  <FormControlLabel
                    control={
                      <Checkbox
                        value="TaxBreakdown"
                        checked={filteredFields?.includes("TaxBreakdown")}
                      />
                    }
                    label="Tax Breakdown"
                  />

                  <FormControlLabel
                    control={
                      <Checkbox
                        value="OptionalService"
                        checked={filteredFields?.includes("OptionalService")}
                      />
                    }
                    label="Optional Services"
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        value="FareCal"
                        checked={filteredFields?.includes("FareCal")}
                      />
                    }
                    label="Fare Calculations"
                  />

                  <FormControlLabel
                    control={
                      <Checkbox
                        value="Service"
                        checked={filteredFields?.includes("Service")}
                      />
                    }
                    label="Service fees"
                  />

                  <FormControlLabel
                    control={
                      <Checkbox
                        value="Hotel"
                        checked={filteredFields?.includes("Hotel")}
                      />
                    }
                    label="Hotel Details"
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        value="Vehicle"
                        checked={filteredFields?.includes("Vehicle")}
                      />
                    }
                    label="Vehicle Details"
                  />

                  <FormControlLabel
                    control={
                      <Checkbox
                        value="Footer"
                        checked={filteredFields?.includes("Footer")}
                        onChange={(e) => {
                          if (e.target.checked) {
                            handleFooterLogoModalOpen(); // Open modal when checkbox is checked
                          }
                        }}
                      />
                    }
                    label="Agency Footer"
                  />
                </FormGroup>
              )}
            </div>
            <div className="head-check-line">
              CHECK-IN COMMENCES
              <StyledTextField
                sx={{
                  width: "1%",
                  marginTop: -0.5,
                  marginLeft: 1,
                  marginRight: 1,
                }}
                value={checkIn_hours}
                onChange={(e) => {
                  const value = e.target.value;
                  // Allow only digits and limit to 2 characters
                  if (/^\d{1,2}$/.test(value) || value === "") {
                    setCheckIn_hours(value);
                  }
                }}
                variant="outlined"
                inputProps={{ style: { padding: 0 } }}
              />
              HOURS PRIOR TO THE SCHEDULED DEPARTURE
            </div>

            {/* Passenger Details */}
            {filteredFields?.includes("PD") && bookingTraveler?.length > 0 && (
              <div className="p-4">
                <h2 className="text-xl font-semibold mb-4">
                  Passenger Details
                </h2>
                <table className="w-full border border-gray-300">
                  <thead>
                    <tr className="bg-gray-200 text-left">
                      <th className="p-2 border">
                        <Checkbox
                          sx={{ marginTop: -1, marginLeft: 0.4 }}
                          value={selectAllPassenger}
                          checked={selectAllPassenger}
                          onChange={handleSelectAllPassenger}
                        />
                      </th>
                      <th className="p-2 border">Passenger Type</th>
                      <th className="p-2 border">Last Name/First Name</th>
                      <th className="p-2 border">Loyalty Program</th>
                      <th className="p-2 border">Disabilities</th>
                      <th className="p-2 border">Electronic Ticket nbr</th>
                    </tr>
                  </thead>
                  {bookingTraveler
                    ?.slice(0, visibleCount)
                    .map((item, index) => (
                      <tbody key={index}>
                        <tr>
                          <td className="p-2 border">
                            <Checkbox
                              sx={{ marginTop: -1, marginLeft: 0.4 }}
                              value={item?.Key}
                              checked={passengerSelection?.includes(item?.Key)}
                              onChange={handlePassengerSelection}
                            />
                          </td>
                          <td className="p-2 border">
                            <Typography>{item?.PassengerType}</Typography>
                          </td>
                          <td className="p-2 border" style={{ width: "30%" }}>
                            <StyledTextField
                              fullWidth
                              value={item?.Name}
                              onChange={(e) => {
                                const value = e.target.value;
                                handlePassengerDataChange(
                                  index,
                                  "Name",
                                  value || ""
                                );
                              }}
                              variant="outlined"
                              inputProps={{
                                style: {
                                  padding: 0,
                                },
                              }}
                            />
                          </td>
                          <td className="p-2 border" style={{ width: "15%" }}>
                            {item?.LoyaltyCard?.map((item) => (
                              <Typography>{item}</Typography>
                            ))}
                          </td>
                          <td className="p-2 border">
                            {item?.Disabilities.length > 0
                              ? item.Disabilities.map((disability, idx) => (
                                <Typography key={idx}>
                                  {disability === "BLND"
                                    ? "Traveler is blind"
                                    : disability === "DEAF"
                                      ? "Traveler is deaf"
                                      : disability}
                                </Typography>
                              ))
                              : null}
                          </td>
                          <td
                            className="p-2 border"
                            style={{
                              display: "flex",
                              justifyContent:
                                filteredFields?.includes("TicketNumber") &&
                                  (item?.Number?.length === 1 || !item?.Number)
                                  ? "flex-start"
                                  : "space-evenly",
                            }}
                          >
                            {filteredFields?.includes("TicketNumber") &&
                              (item?.Number && item.Number.length > 0 ? item.Number : [""]).map(
                                (value, valueindex) => {
                                  return (
                                    <StyledTextField
                                      key={valueindex}
                                      sx={{
                                        width: "35%",
                                      }}
                                      value={value ?? ""} // fallback empty
                                      onChange={(e) => {
                                        const newValue = e.target.value;
                                        handlePassengerDataChange(
                                          index,
                                          `Number.${valueindex}`,
                                          newValue || ""
                                        );
                                      }}
                                      variant="outlined"
                                      inputProps={{
                                        style: {
                                          padding: 0,
                                        },
                                      }}
                                    />
                                  );
                                }
                              )}
                          </td>

                        </tr>
                      </tbody>
                    ))}
                </table>

                {bookingTraveler?.length > visibleCount && (
                  <Grid container justifyContent="center" sx={{ marginTop: 1 }}>
                    <Button onClick={handleSeeMore}>See More</Button>
                  </Grid>
                )}
                {bookingTraveler?.length == visibleCount && (
                  <Grid container justifyContent="center" sx={{ marginTop: 1 }}>
                    <Button onClick={handleSeeLess}>See less</Button>
                  </Grid>
                )}
              </div>
            )}

            {/* Booking Details */}
            <div className="p-4">
              <h2 className="text-xl font-semibold mb-4">Booking Details</h2>
              <table className="w-full border border-gray-300">
                <thead>
                  <tr className="bg-gray-200 text-left">
                    <th className="p-2 border" style={{ width: "30%" }}>
                      Agency Name
                    </th>
                    <th className="p-2 border">Agency Number</th>
                    <th className="p-2 border">Agency Reference</th>
                    <th className="p-2 border">Check-in Reference</th>
                  </tr>
                </thead>
                { }
                <tbody>
                  <tr>
                    <td className="p-2 border">
                      {filteredFields?.includes("AgencyName") ? (
                        agencyName.length > 0 ? (
                          agencyName?.map((item, index) => {
                            return (
                              <StyledTextField
                                key={index}
                                sx={{
                                  marginRight: 2,
                                  marginTop: index > 0 ? 0.5 : 0,
                                  width: "100%",
                                }}
                                value={item}
                                onChange={(e) => {
                                  const newAgencyName = [...agencyName];
                                  newAgencyName[index] = e.target.value;
                                  setAgencyName(newAgencyName);
                                }}
                                variant="outlined"
                                inputProps={{
                                  style: { padding: 0 },
                                }}
                              />
                            );
                          })
                        ) : (
                          <StyledTextField
                            sx={{ margin: 0 }}
                            // value={agencyName}
                            onChange={(e) => {
                              const new_value = e.target.value;
                              setAgencyName([...new_value]);
                            }}
                            variant="outlined"
                            inputProps={{ style: { padding: 0 } }}
                          />
                        )
                      ) : null}
                    </td>
                    <td className="p-2 border">
                      {itinerary_data?.agency_number?.length > 0 ? (
                        itinerary_data?.agency_number?.map((item) => {
                          return <Typography>{item}</Typography>;
                        })
                      ) : (
                        <StyledTextField
                          sx={{ marginRight: 2 }}
                          onChange={(e) => {
                            const new_value = e.target.value;
                            setAgencyNumber([new_value]);
                          }}
                          type="number"
                          variant="outlined"
                          inputProps={{ style: { padding: 0 } }}
                        />
                      )}
                    </td>
                    <td className="p-2 border">
                      {filteredFields?.includes("PNR") &&
                        itinerary_data?.locator && (
                          <StyledTextField
                            sx={{ marginRight: 2 }}
                            value={pnr}
                            onChange={(e) => setPnr(e.target.value)}
                            variant="outlined"
                            inputProps={{ style: { padding: 0 } }}
                          />
                        )}
                    </td>
                    <td className="p-2 border">
                      {filteredFields?.includes("check-in") &&
                        itinerary_data?.supplier_ref?.map((item) => {
                          return (
                            <Typography>
                              {item[0]}/<b>{item[1]}</b>
                            </Typography>
                          );
                        })}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            {/* Flight Details */}
            {air_segments?.length > 0 && (
              <>
                <div className="p-4">
                  <h2 className="text-xl font-semibold mb-4">Flight Details</h2>
                  <table className="w-full border border-gray-300">
                    <thead>
                      <tr className="bg-gray-200 text-left">
                        <th className="p-2 border" style={{ width: "2%" }}>
                          <Checkbox
                            sx={{ marginTop: -1, marginLeft: 1 }}
                            value={selectAllSegment}
                            checked={selectAllSegment}
                            onChange={handleSelectAllSegment}
                          />
                        </th>
                        <th className="p-2 border">Airline</th>
                        <th className="p-2 border">Departure</th>
                        <th className="p-2 border">Arrival</th>
                        <th className="p-2 border">Other Information</th>
                      </tr>
                    </thead>
                    {air_segments?.map((segment, segIndex) => (
                      <tbody>
                        {Object.entries(flightTimesByGroup)?.map(
                          ([key, value]) => {
                            if (
                              value.group === Number(segment.Group) &&
                              value.group !== lastDisplayedGroup
                            ) {
                              lastDisplayedGroup = value.group;

                              return (
                                <tr>
                                  <td
                                    className="p-2 border trcallwarp"
                                    colSpan={5}
                                  >
                                    <div className="otbondcall">
                                      <span sx={{ textTransform: "uppercase" }}>
                                        {key}
                                      </span>
                                      <strong>
                                        Total Duration:{" "}
                                        {value.formattedFlightTime}
                                      </strong>
                                    </div>
                                  </td>
                                </tr>
                              );
                            }

                            // return null;
                          }
                        )}
                        <tr className="segmentrep">
                          <td className="p-2 border">
                            <Checkbox
                              sx={{ marginLeft: 0 }}
                              value={segment.Key}
                              checked={segmentSelection?.includes(segment?.Key)}
                              onChange={handleSegmentSelection}
                            />
                          </td>
                          {/* Airline */}
                          <td className="p-2 border trcallwarp">
                            <div className="airairnlog">
                              <p className="imgairline">
                                <img
                                  src={`data:image/png;base64,${segment.AirlineLogo}`}
                                  alt="Airline Logo"
                                  width="auto"
                                  height="auto"
                                  className="w-32 h-32"
                                // style={{
                                //   verticalAlign: "bottom",
                                //   marginTop: 0,
                                //   maxWidth: "90%",
                                //   marginBottom: 5,
                                // }}
                                />
                              </p>
                              <Typography>{segment?.AirlineName}</Typography>
                              <Typography>{segment?.Flight}</Typography>
                              <Typography>
                                <span style={{ fontWeight: "bold" }}>
                                  Aircraft :
                                </span>{" "}
                                {segment?.AircraftName}
                              </Typography>
                              <Typography>
                                <span style={{ fontWeight: "bold" }}>
                                  Stop(s) :
                                </span>{" "}
                                {segment.NumberOfStops
                                  ? segment.NumberOfStops
                                  : "Non-Stop"}
                                <br />
                                {segment.NumberOfStops
                                  ? segment?.FlightDetails?.slice(
                                    0,
                                    segment.NumberOfStops
                                  )
                                    ?.map((item) => item.ToCity)
                                    ?.join(" / ")
                                  : null}
                              </Typography>

                              <Typography>
                                <span style={{ fontWeight: "bold" }}>
                                  Duration :
                                </span>{" "}
                                {segment.FlightTime}
                              </Typography>
                            </div>
                          </td>

                          {/* Departure */}
                          <td className="p-2 border">
                            {!filteredFields?.includes("stops") ? (
                              // segment?.FlightDetails?.length > 0 ? (
                              //   <div className="departcol">
                              //     <Typography sx={{ fontWeight: "bold" }}>
                              //       <FlightTakeoffIcon />{" "}
                              //       {segment?.FlightDetails[0]?.FromAirport} (
                              //       {segment?.FlightDetails[0]?.From})
                              //     </Typography>
                              //     <Typography>
                              //       {segment?.FlightDetails[0]?.FromCity}
                              //     </Typography>
                              //     <Typography>
                              //       {segment?.FlightDetails[0]?.FromCountry}
                              //     </Typography>
                              //     <Typography sx={{ fontWeight: "bold" }}>
                              //       Departing At
                              //     </Typography>
                              //     <Typography>
                              //       {segment?.FlightDetails[0]?.Departs},{" "}
                              //       <b>
                              //         {segment?.FlightDetails[0]?.DepartsTime}
                              //       </b>
                              //     </Typography>
                              //     <Typography>
                              //       Terminal:{" "}
                              //       {segment?.FlightDetails[0]?.FromTerminal}
                              //     </Typography>
                              //     <Typography
                              //       sx={{
                              //         wordBreak: "break-word",
                              //         whiteSpace: "normal",
                              //         width: "90%",
                              //       }}
                              //     >
                              //       {segment.OperatedBy
                              //         ? `Operated By: ${segment?.OperatedBy}`
                              //         : `Operated By: ${segment?.AirlineName}`}
                              //     </Typography>
                              //   </div>
                              // ) : (
                              <div className="departcol">
                                <Typography sx={{ fontWeight: "bold" }}>
                                  <FlightTakeoffIcon /> {segment?.FromAirport} (
                                  {segment?.From})
                                </Typography>
                                <Typography>{segment?.FromCity}</Typography>
                                <Typography>{segment?.FromCountry}</Typography>
                                <Typography sx={{ fontWeight: "bold" }}>
                                  Departing At
                                </Typography>
                                <Typography>
                                  {segment?.Departs},{" "}
                                  <b>{segment?.DepartsTime}</b>
                                </Typography>
                                <Typography>
                                  Terminal: {segment?.FromTerminal}
                                </Typography>
                                <Typography
                                  sx={{
                                    wordBreak: "break-word",
                                    whiteSpace: "normal",
                                    width: "90%",
                                  }}
                                >
                                  {segment.OperatedBy
                                    ? `Operated By: ${segment?.OperatedBy}`
                                    : `Operated By: ${segment?.AirlineName}`}
                                </Typography>
                              </div>
                            ) : // )
                              segment?.FlightDetails?.length > 0 ? (
                                segment?.FlightDetails?.map(
                                  (flight_details, index) => {
                                    return (
                                      <div
                                        className="departcol"
                                        style={{
                                          marginTop: index > 0 ? "40px" : 0,
                                        }}
                                      >
                                        <Typography sx={{ fontWeight: "bold" }}>
                                          <FlightTakeoffIcon />{" "}
                                          {flight_details?.FromAirport} (
                                          {flight_details?.From})
                                        </Typography>
                                        <Typography>
                                          {flight_details?.FromCity}
                                        </Typography>
                                        <Typography>
                                          {flight_details?.FromCountry}
                                        </Typography>
                                        <Typography sx={{ fontWeight: "bold" }}>
                                          Departing At
                                        </Typography>
                                        <Typography>
                                          {flight_details?.Departs},{" "}
                                          <b>{flight_details?.DepartsTime}</b>
                                        </Typography>
                                        <Typography>
                                          Terminal: {flight_details?.FromTerminal}
                                        </Typography>
                                        <Typography
                                          sx={{
                                            wordBreak: "break-word",
                                            whiteSpace: "normal",
                                            width: "90%",
                                          }}
                                        >
                                          {segment.OperatedBy
                                            ? `Operated By: ${segment?.OperatedBy}`
                                            : `Operated By: ${segment?.AirlineName}`}
                                        </Typography>
                                      </div>
                                    );
                                  }
                                )
                              ) : (
                                <div className="departcol">
                                  <Typography sx={{ fontWeight: "bold" }}>
                                    <FlightTakeoffIcon /> {segment?.FromAirport} (
                                    {segment?.From})
                                  </Typography>
                                  <Typography>{segment?.FromCity}</Typography>
                                  <Typography>{segment?.FromCountry}</Typography>
                                  <Typography sx={{ fontWeight: "bold" }}>
                                    Departing At
                                  </Typography>
                                  <Typography>
                                    {segment?.Departs},{" "}
                                    <b>{segment?.DepartsTime}</b>
                                  </Typography>
                                  <Typography>
                                    Terminal: {segment?.FromTerminal}
                                  </Typography>
                                  <Typography>
                                    {segment.OperatedBy
                                      ? `Operated By: ${segment?.OperatedBy}`
                                      : `Operated By: ${segment?.AirlineName}`}
                                  </Typography>
                                </div>
                              )}
                          </td>

                          {/* Arrival */}
                          <td className="p-2 border">
                            {!filteredFields?.includes("stops") ? (
                              // segment?.FlightDetails?.length > 0 ? (
                              //   <div className="departcol">
                              //     <Typography sx={{ fontWeight: "bold" }}>
                              //       <FlightLandIcon />{" "}
                              //       {
                              //         segment?.FlightDetails[
                              //           segment?.FlightDetails.length - 1
                              //         ]?.ToAirport
                              //       }{" "}
                              //       (
                              //       {
                              //         segment?.FlightDetails[
                              //           segment?.FlightDetails.length - 1
                              //         ]?.To
                              //       }
                              //       )
                              //     </Typography>
                              //     <Typography>
                              //       {
                              //         segment?.FlightDetails[
                              //           segment?.FlightDetails.length - 1
                              //         ]?.ToCity
                              //       }
                              //     </Typography>
                              //     <Typography>
                              //       {
                              //         segment?.FlightDetails[
                              //           segment?.FlightDetails.length - 1
                              //         ]?.ToCountry
                              //       }
                              //     </Typography>
                              //     <Typography sx={{ fontWeight: "bold" }}>
                              //       Arriving At
                              //     </Typography>
                              //     <Typography>
                              //       {
                              //         segment?.FlightDetails[
                              //           segment?.FlightDetails.length - 1
                              //         ]?.Arrives
                              //       }
                              //       ,{" "}
                              //       <b>
                              //         {
                              //           segment?.FlightDetails[
                              //             segment?.FlightDetails.length - 1
                              //           ]?.ArrivesTime
                              //         }
                              //       </b>
                              //     </Typography>
                              //     <Typography>
                              //       Terminal:{" "}
                              //       {
                              //         segment?.FlightDetails[
                              //           segment?.FlightDetails.length - 1
                              //         ]?.ToTerminal
                              //       }
                              //     </Typography>
                              //   </div>
                              // ) : (
                              <div className="departcol">
                                <Typography sx={{ fontWeight: "bold" }}>
                                  <FlightLandIcon /> {segment?.ToAirport} (
                                  {segment?.To})
                                </Typography>
                                <Typography>{segment?.ToCity}</Typography>
                                <Typography>{segment?.ToCountry}</Typography>
                                <Typography sx={{ fontWeight: "bold" }}>
                                  Arriving At
                                </Typography>
                                <Typography>
                                  {segment?.Arrives},{" "}
                                  <b>{segment?.ArrivesTime}</b>
                                </Typography>
                                <Typography>
                                  Terminal: {segment?.ToTerminal}
                                </Typography>
                              </div>
                            ) : // )
                              segment?.FlightDetails?.length > 0 ? (
                                segment?.FlightDetails?.map(
                                  (flight_details, index) => {
                                    return (
                                      <div
                                        className="departcol"
                                        style={{
                                          marginTop: index > 0 ? "60px" : 0,
                                        }}
                                      >
                                        <Typography sx={{ fontWeight: "bold" }}>
                                          <FlightLandIcon />{" "}
                                          {flight_details?.ToAirport} (
                                          {flight_details?.To})
                                        </Typography>
                                        <Typography>
                                          {flight_details?.ToCity}
                                        </Typography>
                                        <Typography>
                                          {flight_details?.ToCountry}
                                        </Typography>
                                        <Typography sx={{ fontWeight: "bold" }}>
                                          Arriving At
                                        </Typography>
                                        <Typography>
                                          {flight_details?.Arrives},{" "}
                                          <b>{flight_details?.ArrivesTime}</b>
                                        </Typography>
                                        <Typography>
                                          Terminal: {flight_details?.ToTerminal}
                                        </Typography>
                                      </div>
                                    );
                                  }
                                )
                              ) : (
                                <div className="departcol">
                                  <Typography sx={{ fontWeight: "bold" }}>
                                    <FlightLandIcon /> {segment?.ToAirport} (
                                    {segment?.To})
                                  </Typography>
                                  <Typography>{segment?.ToCity}</Typography>
                                  <Typography>{segment?.ToCountry}</Typography>
                                  <Typography sx={{ fontWeight: "bold" }}>
                                    Arriving At
                                  </Typography>
                                  <Typography>
                                    {segment?.Arrives},{" "}
                                    <b>{segment?.ArrivesTime}</b>
                                  </Typography>
                                  <Typography>
                                    Terminal: {segment?.ToTerminal}
                                  </Typography>
                                </div>
                              )}
                          </td>

                          {/* Other Information */}
                          <td className="p-2 border">
                            {!filteredFields?.includes("stops") &&
                              segment.NumberOfStops > 0 ? (
                              <>
                                <ul className="sbicc">
                                  <li>
                                    <strong>Status</strong>
                                    <span>
                                      {segment.SegmentStatus ? (
                                        segment.SegmentStatus
                                      ) : (
                                        <HorizontalRuleIcon
                                          sx={{ fontSize: "small" }}
                                        />
                                      )}
                                    </span>
                                  </li>
                                  <li>
                                    <strong>Cabin</strong>
                                    <span>
                                      {segment.Cabin ? (
                                        segment.Cabin
                                      ) : (
                                        <HorizontalRuleIcon
                                          sx={{ fontSize: "small" }}
                                        />
                                      )}
                                    </span>
                                  </li>
                                  <li>
                                    <strong>Booking Class </strong>
                                    {filteredFields?.includes("BC") && (
                                      <span>
                                        {segment.BookingClass ? (
                                          segment.BookingClass
                                        ) : (
                                          <HorizontalRuleIcon
                                            sx={{ fontSize: "small" }}
                                          />
                                        )}
                                      </span>
                                    )}
                                  </li>
                                  <li>
                                    <strong>Co2 Information </strong>
                                    <span>
                                      <HorizontalRuleIcon
                                        sx={{ fontSize: "small" }}
                                      />
                                    </span>
                                  </li>
                                  <li>
                                    <strong>In Flight Service </strong>
                                    <span>
                                      <HorizontalRuleIcon
                                        sx={{ fontSize: "small" }}
                                      />
                                    </span>
                                  </li>
                                </ul>
                                {segment?.is_departed && (
                                  <Grid
                                    sx={{
                                      textAlign: "right",
                                      color: "red",
                                      padding: 0.5,
                                      marginRight: 1,
                                      marginTop: 8,
                                    }}
                                  >
                                    {segment.is_departed
                                      ? "Travel date has passed"
                                      : null}
                                  </Grid>
                                )}
                              </>
                            ) : segment?.FlightDetails?.length > 0 ? (
                              segment?.FlightDetails?.map(
                                (flight_details, index) => {
                                  return (
                                    <div
                                      style={{
                                        marginTop: index > 0 ? "40px" : 0,
                                      }}
                                    >
                                      <ul className="sbicc">
                                        <li>
                                          <strong>Status</strong>
                                          <span>
                                            {segment.SegmentStatus ? (
                                              segment.SegmentStatus
                                            ) : (
                                              <HorizontalRuleIcon
                                                sx={{ fontSize: "small" }}
                                              />
                                            )}
                                          </span>
                                        </li>
                                        <li>
                                          <strong>Cabin</strong>
                                          <span>
                                            {flight_details.Cabin ? (
                                              flight_details.Cabin
                                            ) : (
                                              <HorizontalRuleIcon
                                                sx={{ fontSize: "small" }}
                                              />
                                            )}
                                          </span>
                                        </li>
                                        <li>
                                          <strong>Booking Class </strong>
                                          {filteredFields?.includes("BC") && (
                                            <span>
                                              {segment.BookingClass ? (
                                                segment.BookingClass
                                              ) : (
                                                <HorizontalRuleIcon
                                                  sx={{ fontSize: "small" }}
                                                />
                                              )}
                                            </span>
                                          )}
                                        </li>
                                        <li>
                                          <strong>Co2 Information </strong>
                                          {filteredFields?.includes("Co2") &&
                                            flight_details.CO2Emission ? (
                                            <span>
                                              {flight_details?.CO2Emission}
                                              {flight_details?.Unit}
                                            </span>
                                          ) : (
                                            <span>
                                              <HorizontalRuleIcon
                                                sx={{ fontSize: "small" }}
                                              />
                                            </span>
                                          )}
                                        </li>
                                        <li>
                                          <strong>In Flight Service </strong>
                                          {flight_details.Meal ? (
                                            flight_details?.Meal?.map(
                                              (meal, index) => (
                                                <span>
                                                  {meal}
                                                  {index <
                                                    flight_details.Meal.length -
                                                    1 && " & "}
                                                </span>
                                              )
                                            )
                                          ) : (
                                            <span>
                                              <HorizontalRuleIcon
                                                sx={{ fontSize: "small" }}
                                              />
                                            </span>
                                          )}
                                        </li>
                                      </ul>
                                      {segment?.is_departed && (
                                        <Grid
                                          sx={{
                                            textAlign: "right",
                                            color: "red",
                                            padding: 0.5,
                                            marginRight: 1,
                                          }}
                                        >
                                          {segment.is_departed
                                            ? "Travel date has passed"
                                            : null}
                                        </Grid>
                                      )}
                                    </div>
                                  );
                                }
                              )
                            ) : (
                              <>
                                <ul className="sbicc">
                                  <li>
                                    <strong>Status</strong>
                                    <span>
                                      {segment.SegmentStatus ? (
                                        segment.SegmentStatus
                                      ) : (
                                        <HorizontalRuleIcon
                                          sx={{ fontSize: "small" }}
                                        />
                                      )}
                                    </span>
                                  </li>
                                  <li>
                                    <strong>Cabin</strong>
                                    <span>
                                      {segment.SegmentStatus ? (
                                        segment.SegmentStatus
                                      ) : (
                                        <HorizontalRuleIcon
                                          sx={{ fontSize: "small" }}
                                        />
                                      )}
                                    </span>
                                  </li>
                                  <li>
                                    <strong>Booking Class </strong>
                                    {filteredFields?.includes("BC") && (
                                      <span>
                                        {segment.BookingClass ? (
                                          segment.BookingClass
                                        ) : (
                                          <HorizontalRuleIcon
                                            sx={{ fontSize: "small" }}
                                          />
                                        )}
                                      </span>
                                    )}
                                  </li>
                                  <li>
                                    <strong>Co2 Information </strong>
                                    {filteredFields?.includes("Co2") &&
                                      segment.CO2Emission ? (
                                      <span>
                                        {segment?.CO2Emission} {segment?.Unit}
                                      </span>
                                    ) : (
                                      <HorizontalRuleIcon
                                        sx={{ fontSize: "small" }}
                                      />
                                    )}
                                  </li>
                                  <li>
                                    <strong>In Flight Service </strong>
                                    {segment.Meal ? (
                                      segment?.Meal?.map((meal, index) => (
                                        <>
                                          {meal}
                                          {index < segment.Meal.length - 1 &&
                                            " & "}
                                        </>
                                      ))
                                    ) : (
                                      <HorizontalRuleIcon
                                        sx={{ fontSize: "small" }}
                                      />
                                    )}
                                  </li>
                                </ul>
                                {segment?.is_departed && (
                                  <Grid
                                    sx={{
                                      textAlign: "right",
                                      color: "red",
                                      padding: 0.5,
                                      marginRight: 1,
                                    }}
                                  >
                                    {segment.is_departed
                                      ? "Travel date has passed"
                                      : null}
                                  </Grid>
                                )}
                              </>
                            )}
                          </td>
                        </tr>
                        {segment?.Duration && (
                          <tr>
                            <td className="p-2 border trcallwarp" colSpan={5}>
                              <div className="otbondcall-clock">
                                {segment?.FlightDetails?.length > 1 ? (
                                  <span>
                                    <AccessTimeIcon style={{ fontSize: 20 }} />
                                    Stopover: {segment.Duration} in{" "}
                                    {
                                      segment?.FlightDetails[
                                        segment?.FlightDetails?.length - 1
                                      ]?.ToCity
                                    }
                                  </span>
                                ) : (
                                  <span>
                                    <AccessTimeIcon style={{ fontSize: 20 }} />
                                    Stopover: {segment.Duration} in{" "}
                                    {segment?.ToCity}
                                  </span>
                                )}
                              </div>
                            </td>
                          </tr>
                        )}
                      </tbody>
                    ))}
                  </table>
                </div>

                {/* Passengers's Other details */}
                {bookingTravelerOtherInfo?.length > 0 &&
                  bookingTravelerOtherInfo?.some(
                    (item) => item?.OtherInfo?.length > 0
                  ) && (
                    <div className="p-4">
                      <h2 className="text-xl font-semibold mb-4">
                        Passenger's other details
                      </h2>
                      <table className="w-full border border-gray-300">
                        <thead>
                          <tr className="bg-gray-200 text-left">
                            <th className="p-2 border">
                              Last Name/ First Name
                            </th>
                            <th className="p-2 border">Origin/Destination</th>
                            <th className="p-2 border">Seat Number</th>
                            <th className="p-2 border">Baggage</th>
                            <th className="p-2 border">Meal Preference</th>
                            <th className="p-2 border">Wheelchair</th>
                          </tr>
                        </thead>
                        <tbody>
                          {bookingTravelerOtherInfo
                            ?.slice(0, visibleCount)
                            ?.map((item) => {
                              return (
                                <tr>
                                  <td
                                    className="p-2 border"
                                  // style={{ padding: "10px" }}
                                  >
                                    <Typography>{item?.Name}</Typography>
                                  </td>
                                  <td className="p-2 border">
                                    {item?.OtherInfo?.map((value, index) => (
                                      <Typography>
                                        {value?.From} - {value?.To}
                                      </Typography>
                                    ))}
                                  </td>
                                  <td className="p-2 border">
                                    {item?.OtherInfo?.map((value, index) => (
                                      <Typography>
                                        {value.Seat ? (
                                          value?.Seat
                                        ) : (
                                          <HorizontalRuleIcon
                                            sx={{ fontSize: "small" }}
                                          />
                                        )}
                                      </Typography>
                                    ))}
                                  </td>
                                  <td className="p-2 border">
                                    {item?.OtherInfo?.map((value, index) => (
                                      <Typography>
                                        {value.BaggageAllowance ? (
                                          value?.BaggageAllowance
                                        ) : (
                                          <HorizontalRuleIcon
                                            sx={{ fontSize: "small" }}
                                          />
                                        )}
                                      </Typography>
                                    ))}
                                  </td>
                                  <td className="p-2 border">
                                    {item?.OtherInfo?.map((value, index) => (
                                      <Typography>
                                        {value.MealPreference?.length > 0 ? (
                                          value?.MealPreference?.map(
                                            (item) => `${item}  `
                                          )
                                        ) : (
                                          <HorizontalRuleIcon
                                            sx={{ fontSize: "small" }}
                                          />
                                        )}
                                      </Typography>
                                    ))}
                                  </td>
                                  <td className="p-2 border">
                                    {item?.OtherInfo?.map((value, index) => (
                                      <Typography>
                                        {value.Wheelchair ? (
                                          value.Wheelchair
                                        ) : (
                                          <HorizontalRuleIcon
                                            sx={{ fontSize: "small" }}
                                          />
                                        )}
                                      </Typography>
                                    ))}
                                  </td>
                                </tr>
                              );
                            })}
                        </tbody>
                      </table>
                    </div>
                  )}
              </>
            )}

            {/* Passsenger Fare and Taxes Details */}
            {filteredFields?.includes("Fare") && totalPriceOfAllTickets > 0 ? (
              <div className="p-4">
                <h2 className="text-xl font-semibold mb-4">
                  Passenger Fare and Taxes Details
                </h2>
                <table className="w-full border border-gray-300">
                  <thead>
                    <tr className="bg-gray-200 text-left">
                      <th className="p-2 border">No. of Passenger </th>
                      <th className="p-2 border">Passenger Type</th>
                      <th className="p-2 border">Free</th>
                      <th className="p-2 border">Taxes</th>
                      <th className="p-2 border">Total Amount</th>
                    </tr>
                  </thead>
                  <tbody>
                    {bookingTraveler?.map((item) => {
                      const isFirstOfType = !displayedPassengerTypes.has(
                        item?.PassengerType
                      );

                      if (isFirstOfType) {
                        displayedPassengerTypes.add(item?.PassengerType);
                      }
                      const fare =
                        passengerData[item?.Key]?.fare ||
                        item?.BasePrice ||
                        null;
                      const taxes =
                        passengerData[item?.Key]?.taxes || item?.Taxes || null;

                      return (
                        isFirstOfType && (
                          <>
                            <tr>
                              <td className="p-2 border">
                                {passengerCounts[item?.PassengerType]}
                              </td>
                              <td className="p-2 border">
                                {item?.PassengerType}
                              </td>
                              <td className="p-2 border">
                                <StyledTextField
                                  sx={{ marginRight: 2 }}
                                  value={fare}
                                  onChange={(e) => {
                                    const value = e.target.value.replace(
                                      /[^0-9.]/g,
                                      ""
                                    );
                                    handleFareChange(item?.Key, value);
                                  }}
                                  variant="outlined"
                                  inputProps={{ style: { padding: 0 } }}
                                />
                              </td>
                              <td className="p-2 border">
                                <StyledTextField
                                  sx={{ marginRight: 2 }}
                                  value={taxes}
                                  onChange={(e) => {
                                    const value = e.target.value.replace(
                                      /[^0-9.]/g,
                                      ""
                                    );
                                    handleTaxesChange(item?.Key, value);
                                  }}
                                  variant="outlined"
                                  inputProps={{ style: { padding: 0 } }}
                                />
                              </td>
                              <td className="p-2 border">
                                {(Number(fare) + Number(taxes))?.toFixed(2)}
                              </td>
                            </tr>
                            {filteredFields?.includes("TaxBreakdown") &&
                              item.tax_info && (
                                <tr>
                                  <td
                                    className="p-2 border"
                                    colSpan={3}
                                    style={{
                                      textAlign: "right",
                                      fontWeight: "bold",
                                    }}
                                  >
                                    Tax Breakdown
                                  </td>
                                  <td className="p-2 border">
                                    {item?.tax_info}
                                  </td>
                                </tr>
                              )}
                          </>
                        )
                      );
                    })}
                    <tr>
                      <td
                        className="p-2 border"
                        colSpan={4}
                        style={{
                          textAlign: "right",
                          fontSize: "16px",
                          fontWeight: "bold",
                        }}
                      >
                        Total (in {currency})
                      </td>
                      <td
                        className="p-2 border"
                        style={{ fontSize: "16px", fontWeight: "bold" }}
                      >
                        {totalPriceOfAllTickets}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            ) : null}

            {/* Optional Services */}

            {filteredFields?.includes("OptionalService") &&
              extraCharges?.length > 0 ? (
              <div className="p-4">
                <h2 className="text-xl font-semibold mb-4">
                  Optional Services
                </h2>
                <table className="w-full border border-gray-300">
                  <thead>
                    <tr className="bg-gray-200 text-left">
                      <th className="p-2 border">Optional Services </th>
                      <th className="p-2 border">Passenger Name</th>
                      <th className="p-2 border">EMD Number</th>
                      <th className="p-2 border">Total Cost</th>
                      <th className="p-2 border">Add Charges</th>
                    </tr>
                  </thead>

                  <tbody>
                    {extraCharges?.map((item, index) => {
                      return (
                        <tr>
                          <td className="p-2 border">
                            {item?.OptionalService}
                          </td>
                          <td className="p-2 border">{item?.PassengerName}</td>
                          <td className="p-2 border">
                            {item.EMDNumber ? (
                              item.EMDNumber
                            ) : (
                              <HorizontalRuleIcon sx={{ fontSize: "small" }} />
                            )}
                          </td>
                          <td className="p-2 border">
                            <StyledTextField
                              sx={{ marginRight: 2 }}
                              value={item.TotalCost}
                              onChange={(e) => {
                                const value = e.target.value.replace(
                                  /[^0-9.]/g,
                                  ""
                                );
                                handleExtraChargesDataChange(
                                  index,
                                  "TotalCost",
                                  value
                                );
                              }}
                              variant="outlined"
                              inputProps={{ style: { padding: 0 } }}
                            />
                          </td>
                          <td className="p-2 border">
                            <StyledTextField
                              sx={{ marginRight: 2 }}
                              value={item?.ExchangeTotalPrice}
                              onChange={(e) => {
                                const value = e.target.value.replace(
                                  /[^0-9.]/g,
                                  ""
                                );
                                handleExtraChargesDataChange(
                                  index,
                                  "ExchangeTotalPrice",
                                  value
                                );
                              }}
                              variant="outlined"
                              inputProps={{ style: { padding: 0 } }}
                            />
                          </td>
                        </tr>
                      );
                    })}
                    <tr>
                      <td
                        className="p-2 border"
                        colSpan={4}
                        style={{
                          textAlign: "right",
                          fontSize: "16px",
                          fontWeight: "bold",
                        }}
                      >
                        Total (in {currency})
                      </td>
                      <td
                        className="p-2 border"
                        style={{ fontSize: "16px", fontWeight: "bold" }}
                      >
                        {extraChargesTotalPrice}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            ) : null}

            {/* Add Services Fee */}
            {filteredFields?.includes("Service") && (
              <div className="p-4">
                <h2 className="text-xl font-semibold mb-4">Add Service Fees</h2>
                <table className="w-full border border-gray-300">
                  <thead>
                    <tr className="bg-gray-200 text-left">
                      <th className="p-2 border">
                        <Button
                          size="small"
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            color: "black",
                            height: "100%",
                          }}
                          onClick={handleAddService}
                        >
                          <AddIcon />
                        </Button>
                      </th>
                      <th className="p-2 border">Type of Services</th>
                      <th className="p-2 border">Fees</th>
                    </tr>
                  </thead>
                  <tbody>
                    {services?.map((service, index) => (
                      <tr>
                        <td className="p-2 border">
                          <Button
                            disabled={services.length == 1}
                            size="small"
                            onClick={() => handleRemoveService(index)}
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              color: "black",
                              height: "100%",
                            }}
                          >
                            <DeleteIcon />
                          </Button>
                        </td>
                        <td className="p-2 border">
                          <StyledTextField
                            sx={{ marginRight: 2, width: "50%" }}
                            value={service.type}
                            onChange={(e) =>
                              handleServiceChange(index, "type", e.target.value)
                            }
                            variant="outlined"
                            inputProps={{ style: { padding: 0 } }}
                          />
                        </td>
                        <td className="p-2 border">
                          <StyledTextField
                            sx={{ marginRight: 2, width: "30%" }}
                            value={service.fee}
                            onChange={(e) => {
                              const value = e.target.value.replace(
                                /[^0-9.]/g,
                                ""
                              );
                              handleServiceChange(index, "fee", value);
                            }}
                            variant="outlined"
                            inputProps={{ style: { padding: 0 } }}
                          />
                        </td>
                      </tr>
                    ))}
                    <tr>
                      <td
                        className="p-2 border"
                        colSpan={2}
                        style={{
                          textAlign: "right",
                          fontSize: "16px",
                          fontWeight: "bold",
                        }}
                      >
                        Total (in {currency})
                      </td>
                      <td
                        className="p-2 border"
                        style={{ fontSize: "16px", fontWeight: "bold" }}
                      >
                        {totalServiceFees}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            )}

            {/* Fare Calculation */}
            {filteredFields?.includes("FareCal") &&
              bookingTraveler?.some((item) => item?.fare_calc) && (
                <div className="p-4">
                  <h2 className="text-xl font-semibold mb-4">
                    Fare Calculation
                  </h2>
                  <table className="w-full border border-gray-300">
                    <tbody>
                      {bookingTraveler?.map((item) => {
                        const isFirstOfType =
                          !displayedPassengerTypesFareCalc.has(
                            item?.PassengerType
                          );

                        if (isFirstOfType) {
                          displayedPassengerTypesFareCalc.add(
                            item?.PassengerType
                          );
                        }
                        return (
                          isFirstOfType && (
                            <tr>
                              <td className="p-2 border">
                                {item?.PassengerType}
                              </td>
                              <td className="p-2 border">{item?.fare_calc}</td>
                            </tr>
                          )
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              )}

            {/* Baggage and carry on allowance */}

            {filteredFields?.includes("Baggage") ? (
              itinerary_data?.baggage_allowance?.length > 0 ||
                itinerary_data?.carry_on_allowance_info?.length > 0 ? (
                <div className="p-4">
                  <h2 className="text-xl font-semibold mb-4">
                    Baggage and Carry on Allowance
                  </h2>
                  {itinerary_data?.baggage_allowance?.length > 0 && (
                    <>
                      <h3 className="text-xl font-semibold mb-4 fss">
                        Baggage Allowance
                      </h3>

                      <table className="w-full border border-gray-300">
                        <thead>
                          <tr className="bg-gray-200 text-left">
                            <th className="p-2 border">Passenger Type </th>
                            <th className="p-2 border">Origin/Destination</th>
                            <th className="p-2 border">Baggage</th>
                            <th className="p-2 border">Information</th>
                          </tr>
                        </thead>

                        <tbody>
                          {travelerTypeOrder?.map((travelerType) => {
                            return displayBaggage[travelerType].length > 0 ? (
                              <>
                                <tr>
                                  <td
                                    className="p-2 border"
                                    colSpan={4}
                                    style={{ backgroundColor: "#f5f6f6" }}
                                  >
                                    {travelerType}
                                  </td>
                                </tr>
                                {displayBaggage[travelerType]?.map(
                                  (item, index) => {
                                    const isFirstOfItsKind =
                                      index === 0 ||
                                      displayBaggage[travelerType][index - 1]
                                        .From !== item.From ||
                                      displayBaggage[travelerType][index - 1]
                                        .To !== item.To;
                                    return (
                                      isFirstOfItsKind && (
                                        <tr>
                                          <td className="p-2 border"></td>
                                          <td className="p-2 border">{`${item.From} - ${item.To}`}</td>
                                          <td className="p-2 border">
                                            <Typography>
                                              {item?.baggage?.map(
                                                (bag, index) => (
                                                  <>
                                                    <span
                                                      style={{
                                                        fontWeight: "bold",
                                                        marginLeft:
                                                          index > 0 ? 10 : 0,
                                                      }}
                                                    >
                                                      {index + 1 === 1
                                                        ? "1st"
                                                        : index + 1 === 2
                                                          ? "2nd"
                                                          : index + 1 === 3
                                                            ? "3rd"
                                                            : `${index + 1}th`}{" "}
                                                      Checked Bag:
                                                    </span>
                                                    <span>{bag[0]}</span>
                                                    {index !==
                                                      item?.baggage?.length -
                                                      1 && <span>,</span>}
                                                  </>
                                                )
                                              )}
                                            </Typography>
                                          </td>
                                          <td
                                            className="p-2 border"
                                            style={{ width: "20%" }}
                                          >
                                            <Typography
                                              sx={{
                                                textTransform: "capitalize",
                                              }}
                                            >
                                              {item.baggage_info[2]}
                                            </Typography>
                                          </td>
                                        </tr>
                                      )
                                    );
                                  }
                                )}
                              </>
                            ) : null;
                          })}
                        </tbody>
                      </table>
                    </>
                  )}

                  {itinerary_data?.carry_on_allowance_info?.length > 0 && (
                    <div className="p-4">
                      <h3 className="text-xl font-semibold mb-4 fss">
                        Carry on Allowance
                      </h3>

                      <table className="w-full border border-gray-300">
                        <thead>
                          <tr className="bg-gray-200 text-left">
                            <th className="p-2 border">Origin/Destination </th>
                            <th className="p-2 border">Baggage</th>
                            <th className="p-2 border">Information</th>
                          </tr>
                        </thead>
                        <tbody>
                          {itinerary_data?.carry_on_allowance_info?.map(
                            (item) => {
                              return (
                                <tr>
                                  <td className="p-2 border">{`${item?.From} - ${item?.To}`}</td>
                                  <td className="p-2 border">
                                    {item?.carry_on?.[0]}
                                  </td>
                                  <td className="p-2 border">
                                    {item?.carry_on?.[1]}
                                  </td>
                                </tr>
                              );
                            }
                          )}
                        </tbody>
                      </table>
                    </div>
                  )}
                </div>
              ) : null
            ) : null}

            {/* Hotel Details */}

            {filteredFields?.includes("Hotel") &&
              itinerary_data?.hotel_info?.length > 0 ? (
              <div className="p-4">
                <h2 className="text-xl font-semibold mb-4">Hotel Details</h2>
                <table className="w-full border border-gray-300">
                  <thead>
                    <tr className="bg-gray-200 text-left">
                      <th className="p-2 border">Name</th>
                      <th className="p-2 border">Address</th>
                      <th className="p-2 border">Other Information</th>
                    </tr>
                  </thead>
                  <tbody>
                    {itinerary_data?.hotel_info?.map((item, index) => {
                      return (
                        <tr>
                          <td className="p-2 border">{item?.Name}</td>
                          <td className="p-2 border">
                            {item?.Address?.map((item) => (
                              <Typography>{item}</Typography>
                            ))}
                          </td>
                          <td
                            className="p-2 border"
                          // style={{ border: "1px solid red" }}
                          >
                            <ul className="sbicc">
                              <li>
                                <strong>Check-in</strong>
                                <span>{item?.CheckIn}</span>
                              </li>
                              <li>
                                <strong>Check-out</strong>
                                <span>{item?.CheckOut}</span>
                              </li>
                              <li>
                                <strong>Room(s)</strong>
                                <span>{item?.Rooms}</span>
                              </li>
                              <li>
                                <strong>Nights</strong>
                                <span>{item?.Nights}</span>
                              </li>
                              <li>
                                <strong>Person(s)</strong>
                                <span>{item?.Persons}</span>
                              </li>
                              <li>
                                <strong>Status</strong>
                                <span>{item?.Status}</span>
                              </li>
                              <li>
                                <strong>Confirmation Number</strong>
                                <span>{item?.ConfirmationNumber}</span>
                              </li>
                              <li>
                                <strong>Phone Number</strong>
                                <span>{item?.PhoneNumberHotel}</span>
                              </li>
                              <li>
                                <strong>Cancel Dead Line</strong>
                                <span>{item?.CancelDeadLine}</span>
                              </li>
                              <li>
                                <strong>Rate Plan Type</strong>
                                <span>{item?.RatePlanType}</span>
                              </li>
                            </ul>
                          </td>
                        </tr>
                      );
                    })}
                    <tr className="bg-gray-200 text-left">
                      <th className="p-2 border">Passenger</th>
                      <th className="p-2 border" colSpan={2}>
                        Total Cost
                      </th>
                    </tr>
                    {itinerary_data?.hotel_info?.map((item, index) => {
                      return (
                        <tr>
                          <td className="p-2 border">{item?.PassengerName}</td>
                          <td className="p-2 border">
                            <StyledTextField
                              value={hotelTotal}
                              onChange={(e) => setHotelTotal(e.target.value)}
                              sx={{ width: "30%" }}
                              variant="outlined"
                              inputProps={{
                                style: {
                                  padding: 0,
                                },
                              }}
                            />
                          </td>
                        </tr>
                      );
                    })}
                    <tr>
                      <td
                        className="p-2 border"
                        colSpan={2}
                        style={{
                          textAlign: "right",
                          fontSize: "16px",
                          fontWeight: "bold",
                        }}
                      >
                        Total (in {currency})
                      </td>
                      <td
                        className="p-2 border"
                        style={{ fontSize: "16px", fontWeight: "bold" }}
                      >
                        {hotelTotal}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            ) : null}

            {/* Vehicle Details */}

            {/* Remark Information */}
            {(filteredFields?.includes("UR") ||
              filteredFields?.includes("di") ||
              filteredFields?.includes("pr")) &&
              (itinerary_data?.remarks?.length > 0 ||
                itinerary_data?.di_remarks?.length > 0 ||
                itinerary_data?.passive_remarks?.length > 0) && (
                <div className="p-4">
                  <h2 className="text-xl font-semibold mb-4">
                    Remark Information
                  </h2>

                  {filteredFields?.includes("UR") &&
                    itinerary_data?.remarks?.length > 0 ? (
                    <>
                      <h3 className="text-xl font-semibold mb-4 fss">
                        Unassociated Remarks
                      </h3>

                      {itinerary_data?.remarks?.map((item) => {
                        return (
                          <tr>
                            <td className="p-2 border">
                              <Checkbox
                                sx={{ marginTop: -1, marginLeft: 1 }}
                                value={item}
                                checked={remarkInfo?.includes(item)}
                                onChange={() => handleRemarkSelection(item)}
                              />
                            </td>
                            <td className="p-2 border">{item}</td>
                          </tr>
                        );
                      })}
                    </>
                  ) : null}

                  {filteredFields?.includes("di") &&
                    itinerary_data?.di_remarks?.length > 0 ? (
                    <>
                      <h3 className="text-xl font-semibold mb-4 fss">
                        Accounting Remarks (DI)
                      </h3>

                      {itinerary_data?.di_remarks?.map((item) => {
                        return (
                          <tr>
                            <td className="p-2 border">
                              <Checkbox
                                sx={{ marginTop: -1, marginLeft: 1 }}
                                value={item}
                                checked={diRemark?.includes(item)}
                                onChange={() => handleDIRemarkSelection(item)}
                              />
                            </td>
                            <td className="p-2 border">{item}</td>
                          </tr>
                        );
                      })}
                    </>
                  ) : null}

                  {filteredFields?.includes("pr") &&
                    itinerary_data?.passive_remarks?.length > 0 ? (
                    <>
                      <h3 className="text-xl font-semibold mb-4 fss">
                        Passive Remarks
                      </h3>

                      {itinerary_data?.passive_remarks?.map((item) => {
                        return (
                          <tr>
                            <td className="p-2 border">
                              <Checkbox
                                sx={{ marginTop: -1, marginLeft: 1 }}
                                value={item}
                                checked={passiveRemark?.includes(item)}
                                onChange={() =>
                                  handlePassiveRemarksSelection(item)
                                }
                              />
                            </td>
                            <td className="p-2 border">{item}</td>
                          </tr>
                        );
                      })}
                    </>
                  ) : null}
                </div>
              )}
          </div>
        </div>

        <Modal open={openModal} onClose={handleCloseModal}>
          <Box className="modalStyle">
            <Grid container sx={{ fontSize: 18 }}>
              {/* <Grid
              xs={12}
              sx={{ textAlign: "center", marginBottom: 4, fontSize: 25 }}
            >
              EMAIL ITINERARY
            </Grid> */}
              <Grid item xs={12} sx={{ marginTop: 2 }}>
                <FormControl>
                  <FormLabel
                    sx={{
                      color: "black !important",
                      fontSize: 20,
                      fontWeight: "bold",
                      marginBottom: 1,
                    }}
                  >
                    Please select your preferred PDF itinerary from the options
                    below.
                  </FormLabel>
                  <RadioGroup
                    // defaultValue={pdfChoice}
                    value={pdfChoice}
                    onChange={(e) => setpdfChoice(e.target.value)}
                  >
                    {selectAllPassenger && (
                      <FormControlLabel
                        value="PDFA"
                        control={<Radio />}
                        label="PDF for all Pax"
                      />
                    )}
                    {selectAllPassenger && (
                      <FormControlLabel
                        value="PDFI"
                        control={<Radio />}
                        label="PDF for all individual Pax"
                      />
                    )}

                    {!selectAllPassenger && (
                      <FormControlLabel
                        value="PDFS"
                        control={<Radio />}
                        label="PDF for selected Pax"
                      />
                    )}
                  </RadioGroup>
                </FormControl>
              </Grid>
              <Grid xs={12} sx={{ marginBottom: 1, marginTop: 2 }}>
                TO
              </Grid>
              <Grid xs={12}>
                <TextField
                  fullWidth
                  placeholder="Enter TO email"
                  value={customerEmail}
                  onChange={(e) => setCustomerEmail(e.target.value)}
                />
              </Grid>
              <Grid xs={12} sx={{ marginBottom: 1, marginTop: 2 }}>
                CC
              </Grid>
              <Grid xs={12}>
                <TextField
                  fullWidth
                  placeholder="Enter CC email"
                  value={customerCC}
                  onChange={(e) => setCustomerCC(e.target.value)}
                />
              </Grid>
              <Grid item xs={12} sx={{ marginTop: 2 }}>
                <FormControl>
                  <FormLabel
                    sx={{
                      color: "black !important",
                      // fontSize: 20,
                      // fontWeight: "bold",
                      marginBottom: 1,
                    }}
                  >
                    Select language
                  </FormLabel>
                  <RadioGroup
                    row
                    defaultValue={language}
                    value={language}
                    onChange={(e) => setLanguage(e.target.value)}
                  >
                    <FormControlLabel
                      value="en"
                      control={<Radio />}
                      label="English"
                    />
                    <FormControlLabel
                      value="fr"
                      control={<Radio />}
                      label="French"
                    />
                    <FormControlLabel
                      value="tr"
                      control={<Radio />}
                      label="Turkish"
                    />
                    <FormControlLabel
                      value="zh"
                      control={<Radio />}
                      label="Chinese"
                    />
                    <FormControlLabel
                      value="ar"
                      control={<Radio />}
                      label="Arabic"
                    />
                    <FormControlLabel
                      value="es"
                      control={<Radio />}
                      label="Spanish"
                    />
                  </RadioGroup>
                </FormControl>
              </Grid>
              <DialogActions className="svvanbtn">
                <Button onClick={handleSendEmail} color="primary">
                  Send
                </Button>
              </DialogActions>
              {errorAlert && (
                <Grid
                  xs={12}
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    marginTop: 4,
                    color: "red",
                  }}
                >
                  {errorAlertMessage}
                </Grid>
              )}
            </Grid>
          </Box>
        </Modal>
        <Modal open={openPDFModal} onClose={handleClosePDFModal}>
          <Box className="modalStyle" style={{ width: "500px" }}>
            <Grid container sx={{ fontSize: 18 }}>
              <Grid item xs={12} sx={{ marginTop: 2 }}>
                <FormControl>
                  <FormLabel
                    sx={{
                      color: "black !important",
                      fontSize: 20,
                      fontWeight: "bold",
                      marginBottom: 1,
                    }}
                  >
                    Select language
                  </FormLabel>
                  <RadioGroup
                    row
                    defaultValue={language}
                    value={language}
                    onChange={(e) => setLanguage(e.target.value)}
                  >
                    <FormControlLabel
                      value="en"
                      control={<Radio />}
                      label="English"
                    />
                    <FormControlLabel
                      value="fr"
                      control={<Radio />}
                      label="French"
                    />
                    <FormControlLabel
                      value="tr"
                      control={<Radio />}
                      label="Turkish"
                    />
                    <FormControlLabel
                      value="zh"
                      control={<Radio />}
                      label="Chinese"
                    />
                    <FormControlLabel
                      value="ar"
                      control={<Radio />}
                      label="Arabic"
                    />
                    <FormControlLabel
                      value="es"
                      control={<Radio />}
                      label="Spanish"
                    />
                  </RadioGroup>
                </FormControl>
              </Grid>
              <DialogActions className="svvanbtn">
                <Button onClick={handlePrintToPDF} color="primary">
                  Send
                </Button>
              </DialogActions>
            </Grid>
          </Box>
        </Modal>

        {/* Header Logo */}
        <Modal open={headerLogoModalOpen} onClose={handleHeaderLogoModalClose}>
          <Box className="modalStyle" style={{ width: "400px" }}>
            <Typography variant="h6" gutterBottom>
              Select a Header Logo
            </Typography>
            {decodedToken?.role === "customer_user" ? (
              header_logo?.length > 0 ? (
                <Grid container spacing={2} sx={{ marginTop: 2 }}>
                  {header_logo?.map((logo) => (
                    <Grid item xs={12} key={logo.logo_id}>
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          border: "1px solid #ccc",
                          padding: "10px",
                          borderRadius: "5px",
                          cursor: "pointer",
                          backgroundColor:
                            selectedHeaderLogo === logo.logo_id
                              ? "#5d8b57"
                              : "white",
                        }}
                        onClick={() => setSelectedHeaderLogo(logo.logo_id)}
                      >
                        <img
                          src={`data:image/png;base64,${logo.logo}`}
                          alt={logo.name.trim()}
                          style={{
                            width: "150px",
                            height: "50px",
                            objectFit: "contain",
                          }}
                        />
                        <Typography
                          sx={{
                            fontWeight:
                              selectedHeaderLogo === logo.logo_id ? "bold" : "",
                            color:
                              selectedHeaderLogo === logo.logo_id
                                ? "white"
                                : "black",
                          }}
                        >
                          {logo.name.trim()}
                        </Typography>
                      </Box>
                    </Grid>
                  ))}
                </Grid>
              ) : (
                <Typography color="red" sx={{ marginTop: 2 }}>
                  No header logos. Please upload or select logos from profile.
                </Typography>
              )
            ) : null}

            {decodedToken?.role === "customer" ? (
              customer_header_logo?.length > 0 ? (
                <Grid container spacing={2} sx={{ marginTop: 2 }}>
                  <Grid item xs={12}>
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        border: "1px solid #ccc",
                        padding: "10px",
                        borderRadius: "5px",
                        cursor: "pointer",
                        backgroundColor: customer_main_header_logo
                          ? "#5d8b57"
                          : "white",
                      }}
                      onClick={() => {
                        // setSelectedCustomerHeaderLogo(null);
                        setCustomer_main_header_logo((prev) => !prev);
                      }}
                    >
                      <Typography
                        sx={{
                          fontWeight: customer_main_header_logo ? "bold" : "",
                          color: customer_main_header_logo ? "white" : "black",
                        }}
                      >
                        Default Header logo
                      </Typography>
                    </Box>
                  </Grid>
                  {customer_header_logo?.map((logo) => (
                    <Grid item xs={12} key={logo.logo_id}>
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          border: "1px solid #ccc",
                          padding: "10px",
                          borderRadius: "5px",
                          cursor: "pointer",
                          backgroundColor:
                            !customer_main_header_logo &&
                              selectedCustomerHeaderLogo === logo.logo_id
                              ? "#5d8b57"
                              : "white",
                        }}
                        onClick={() => {
                          setSelectedCustomerHeaderLogo(logo.logo_id);
                          setCustomer_main_header_logo(false);
                        }}
                      >
                        <img
                          src={`data:image/png;base64,${logo.logo}`}
                          alt={logo.name.trim()}
                          style={{
                            width: "150px",
                            height: "50px",
                            objectFit: "contain",
                          }}
                        />
                        <Typography
                          sx={{
                            fontWeight:
                              !customer_main_header_logo &&
                                selectedCustomerHeaderLogo === logo.logo_id
                                ? "bold"
                                : "",
                            color:
                              !customer_main_header_logo &&
                                selectedCustomerHeaderLogo === logo.logo_id
                                ? "white"
                                : "black",
                          }}
                        >
                          {logo.name.trim()}
                        </Typography>
                      </Box>
                    </Grid>
                  ))}
                </Grid>
              ) : (
                <Typography color="red" sx={{ marginTop: 2 }}>
                  No header logos. Please upload or select logos from profile.
                </Typography>
              )
            ) : null}

            <DialogActions>
              <Button
                onClick={
                  decodedToken?.role === "customer_user"
                    ? handleCustomerUserDefaultHeaderLogo
                    : handleCustomerDefaultHeaderLogo
                }
                color="primary"
              >
                Save
              </Button>
              <Button onClick={handleHeaderLogoModalClose} color="secondary">
                Cancel
              </Button>
            </DialogActions>
          </Box>
        </Modal>

        {/* Footer Logo */}
        <Modal open={footerLogoModalOpen} onClose={handleFooterLogoModalClose}>
          <Box className="modalStyle" style={{ width: "400px" }}>
            <Typography variant="h6" gutterBottom>
              Select a Footer Logo
            </Typography>

            {decodedToken?.role === "customer_user" ? (
              footer_logo?.length > 0 ? (
                <Grid container spacing={2} sx={{ marginTop: 2 }}>
                  {footer_logo?.map((logo) => (
                    <Grid item xs={12} key={logo.logo_id}>
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          border: "1px solid #ccc",
                          padding: "10px",
                          borderRadius: "5px",
                          cursor: "pointer",
                          backgroundColor:
                            !customer_main_footer_logo &&
                              selectedFooterLogo === logo.logo_id
                              ? "#5d8b57"
                              : "white",
                        }}
                        onClick={() => setSelectedFooterLogo(logo.logo_id)}
                      >
                        <img
                          src={`data:image/png;base64,${logo.logo}`}
                          alt={logo.name.trim()}
                          style={{
                            width: "150px",
                            height: "50px",
                            objectFit: "contain",
                          }}
                        />
                        <Typography
                          sx={{
                            fontWeight:
                              !customer_main_footer_logo &&
                                selectedFooterLogo === logo.logo_id
                                ? "bold"
                                : "",
                            color:
                              !customer_main_footer_logo &&
                                selectedFooterLogo === logo.logo_id
                                ? "white"
                                : "black",
                          }}
                        >
                          {logo.name.trim()}
                        </Typography>
                      </Box>
                    </Grid>
                  ))}
                </Grid>
              ) : (
                <Typography color="red" sx={{ marginTop: 2 }}>
                  No footer logos. Please upload or select logos from profile.
                </Typography>
              )
            ) : null}

            {decodedToken?.role === "customer" ? (
              customer_footer_logo?.length > 0 ? (
                <Grid container spacing={2} sx={{ marginTop: 2 }}>
                  <Grid item xs={12}>
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        border: "1px solid #ccc",
                        padding: "10px",
                        borderRadius: "5px",
                        cursor: "pointer",
                        backgroundColor: customer_main_footer_logo
                          ? "#5d8b57"
                          : "white",
                      }}
                      onClick={() => {
                        // setSelectedCustomerFooterLogo(null);
                        setCustomer_main_footer_logo((prev) => !prev);
                      }}
                    >
                      <Typography
                        sx={{
                          fontWeight: customer_main_footer_logo ? "bold" : "",
                          color: customer_main_footer_logo ? "white" : "black",
                        }}
                      >
                        Default Footer logo
                      </Typography>
                    </Box>
                  </Grid>
                  {customer_footer_logo?.map((logo) => (
                    <Grid item xs={12} key={logo.logo_id}>
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          border: "1px solid #ccc",
                          padding: "10px",
                          borderRadius: "5px",
                          cursor: "pointer",
                          backgroundColor:
                            !customer_main_footer_logo &&
                              selectedCustomerFooterLogo === logo.logo_id
                              ? "#5d8b57"
                              : "white",
                        }}
                        onClick={() => {
                          setSelectedCustomerFooterLogo(logo.logo_id);
                          setCustomer_main_footer_logo(false);
                        }}
                      >
                        <img
                          src={`data:image/png;base64,${logo.logo}`}
                          alt={logo.name.trim()}
                          style={{
                            width: "150px",
                            height: "50px",
                            objectFit: "contain",
                          }}
                        />
                        <Typography
                          sx={{
                            fontWeight:
                              !customer_main_footer_logo &&
                                selectedCustomerFooterLogo === logo.logo_id
                                ? "bold"
                                : "",
                            color:
                              !customer_main_footer_logo &&
                                selectedCustomerFooterLogo === logo.logo_id
                                ? "white"
                                : "black",
                          }}
                        >
                          {logo.name.trim()}
                        </Typography>
                      </Box>
                    </Grid>
                  ))}
                </Grid>
              ) : (
                <Typography color="red" sx={{ marginTop: 2 }}>
                  No footer logos. Please upload or select logos from profile.
                </Typography>
              )
            ) : null}

            <DialogActions>
              <Button
                onClick={
                  decodedToken?.role === "customer_user"
                    ? handleCustomerUserDefaultFooterLogo
                    : handleCustomerDefaultFooterLogo
                }
                color="primary"
              >
                Save
              </Button>
              <Button onClick={handleFooterLogoModalClose} color="secondary">
                Cancel
              </Button>
            </DialogActions>
          </Box>
        </Modal>

        {emailItineraryInfo && (
          <Snackbar
            open={snackOpen}
            autoHideDuration={5000}
            onClose={handleSnackClose}
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
            sx={{ width: "20%" }}
          >
            <Alert
              onClose={handleSnackClose}
              severity="success"
              sx={{ width: "100%" }}
            >
              <AlertTitle>Success</AlertTitle>
              {emailItineraryInfo}
            </Alert>
          </Snackbar>
        )}
        {emailItineraryError && (
          <Snackbar
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
            open={snackOpen}
            autoHideDuration={3000}
            onClose={handleSnackClose}
            sx={{ width: "20%" }}
          >
            <Alert
              onClose={handleSnackClose}
              severity="error"
              sx={{ width: "100%" }}
            >
              <AlertTitle>Error</AlertTitle>
              {emailItineraryError}
            </Alert>
          </Snackbar>
        )}
      </div>
      {emailItineraryLoading && <FullPageLoader open={emailItineraryLoading} />}
      {printItineraryLoading && <FullPageLoader open={printItineraryLoading} />}
    </>
  );
}
